/* cf-job-ui.js — Click Fencing, 2026-09-23. PHASE 2 of mixed fence types.
 *
 * Phase 1 (assets/cf-job.js) let a customer combine saved quotes into one job ON THE
 * QUOTE PAGE. This file is the rest of what Pete asked for: the job follows the customer
 * around, and they can switch fence type in the middle of designing.
 *
 *   1. THE JOB STRIP — on all four calculators and on /pages/quote-review: a chip per
 *      fence with its length and price, the job total, the job's look, and one button to
 *      review the whole job. Tapping another fence's chip reopens that fence in its own
 *      calculator with the design restored.
 *   2. THE FENCE TYPE IS CHOSEN AT "+ ADD SECTION" (2026-09-25 — the old "+ Another fence
 *      type" buttons beside it and in the strip are gone). In a mixed job "+ Add section"
 *      asks which fence; another fence joins the PLAN, and the strip's "Continue to
 *      <fence> →" saves this one as a run and opens that fence with the job carried across.
 *   3. THE LOOK — one colour and one fixing for the whole job, chosen once (Pete, 22 Sep:
 *      keeping every section the same when only glass has Mirror and only aluminium has
 *      Monument). Applied by pressing each calculator's OWN controls, so every price still
 *      comes from the calculator.
 *
 * NOTHING HERE EDITS A CALCULATOR. It reads state, presses real controls, and uses each
 * calculator's own save and restore paths:
 *   save    — proceedToQuotePage() where it exists, else the page's own Add to Cart
 *             (PerfMesh has no proceedToQuotePage; that is not a bug, it is how it is).
 *   restore — sessionStorage 'ullc_quote' + '<prefix>_quote_return', which is the path the
 *             calculators already use to come back from the quote page.
 *
 * 🔴 THE HOP. A calculator's save always ends by navigating to /pages/quote-review, and
 * window.location.href cannot be intercepted. So switching fence type saves, lands on the
 * quote page for a moment behind a "Saving your <fence>…" panel, and is sent straight on
 * to the next calculator. The customer sees one screen, not two.
 *
 * Self-installing, idempotent, every path wrapped. A fault here must never break a
 * calculator or a quote: if CF_JOB is missing, this file does nothing at all.
 */
(function () {
  'use strict';
  if (window.__cfJobUiInstalled) return;
  window.__cfJobUiInstalled = true;

  var J0 = window.CF_JOB;
  if (!J0) return;

  /* 2026-09-26 (Pete: "make the single type of fence work how it used to. it seems no matter
     what you choose now it wants to do a mixed fence" … "when we do a mixed fence its a special
     add sections page").
     A job saved in localStorage outlives the visit, so one mixed job — even an abandoned one —
     used to put every later visit into mixed mode. Now mixed behaviour runs ONLY while a mixed
     job is ACTIVE in this browser tab: started on the mixed-fence planner page (hub ?job=new),
     flagged in sessionStorage. Everything else is the single-fence calculator exactly as it was.
     J is a view of CF_JOB whose plan reads empty unless the job is active; the quote page's own
     job merge (J0) is untouched. */
  var ACTIVE_KEY = 'cf_job_active';
  function jobActive() {
    try {
      if (sessionStorage.getItem(ACTIVE_KEY) !== '1') return false;
      var s = J0.state();
      var items = (s.plan && s.plan.items) || [], runs = s.runs || [];
      /* 26 Sep (Pete: "whats missing is configure each section seperately"): the flag lives for
         the whole browser tab, so a calculator opened from the menu while a job was still on
         lost its "Are all sections the same?" switch and was stuck on all-the-same. On a
         calculator page the job only applies when THAT fence type is in the job; any other
         calculator is the ordinary single-fence one. */
      var ct = currentCalc();
      if (ct) {
        if (items.length) return items.some(function (it) { return it.calcType === ct; });
        return !!s.on && runs.some(function (r) { return r.calcType === ct; });
      }
      return !!(items.length || runs.length || s.mixIntent);
    } catch (e) { return false; }
  }
  function setActive(on) {
    try { if (on) sessionStorage.setItem(ACTIVE_KEY, '1'); else sessionStorage.removeItem(ACTIVE_KEY); } catch (e) {}
  }
  function exitJob() {
    setActive(false);
    try { localStorage.removeItem('cf_job'); } catch (e) {}
    ['cf_job_applied', 'cf_plan_prefill', 'cf-job-arrive', 'cf_job_goto', 'cf_job_hop'].forEach(function (k) {
      try { sessionStorage.removeItem(k); } catch (e) {}
    });
    try {
      var kill = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && (k.indexOf('cf-calc:') === 0 || k.indexOf('cf-fresh-hold:') === 0)) kill.push(k);
      }
      kill.forEach(function (k) { try { sessionStorage.removeItem(k); } catch (e) {} });
    } catch (e) {}
  }
  var J = Object.create(J0);
  J.getPlan = function () { return jobActive() ? J0.getPlan() : null; };
  J.planItemsForCalc = function (ct) { return jobActive() ? J0.planItemsForCalc(ct) : []; };
  J.planCalcOrder = function () { return jobActive() ? J0.planCalcOrder() : []; };
  J.planNextCalc = function (after) { return jobActive() ? J0.planNextCalc(after) : null; };

  var HOP_KEY   = 'cf_job_hop';
  var PLAN_PREFILL_KEY = 'cf_plan_prefill';        // 2026-09-24: carries {calcType, items, at, reopen} to the next arrival
  var PATHS     = J.CALC_PATH;                    // calcType -> /pages/…
  var FENCE     = J.FENCE_LABEL;                  // calcType -> "Frameless Glass"
  var STORE_PREFIX = { Frameless: 'ullc', PerfMesh: 'perfmesh', FlatTop: 'flattop', Blade: 'blade' };
  var QUOTE_PAGE   = '/pages/quote-review';

  /* 2026-09-26 (Pete: "Glass S1 - Blade S2", colour lost going back to glass, "each section
     will need to be configured differently"). */
  var SHORT       = { Frameless: 'Glass', PerfMesh: 'PerfMesh', FlatTop: 'Flat Top', Blade: 'Blade' };
  var ARRIVE_KEY  = 'cf-job-arrive';     // {path, mode:'resume'|'fresh', at} — read by cf-fresh-start.js too
  var GOTO_KEY    = 'cf_job_goto';       // {calcType, local, at} — which of its sections to open on arrival
  var APPLIED_KEY = 'cf_job_applied';    // job choices already pressed into a control, once each

  /* The look. Only Black and White exist on every fence; Mirror is glass-only hardware and
     Monument is aluminium-only, so those two are offered as NAMED PAIRS and the card says
     which fence gets which. Values are exactly what the calculators' own controls take. */
  var LOOKS = [
    { id: 'black',    name: 'All Black',             glass: 'Black',  alu: 'satin-black', match: true,
      note: 'Black glass hardware, Satin Black aluminium' },
    { id: 'white',    name: 'All White',             glass: 'White',  alu: 'white',       match: true,
      note: 'White glass hardware, White aluminium' },
    { id: 'ss-black', name: 'Stainless + Black',     glass: 'Mirror', alu: 'satin-black', match: false, mixOnly: true,
      note: 'Mirror spigots on the glass, Satin Black aluminium' },
    { id: 'ss-mon',   name: 'Stainless + Monument',  glass: 'Mirror', alu: 'monument',    match: false, mixOnly: true,
      note: 'Mirror spigots on the glass, Monument aluminium' },
    { id: 'mirror',   name: 'All Mirror',            glass: 'Mirror', alu: null,          match: true, glassOnly: true,
      note: 'Mirror stainless hardware' },
    { id: 'monument', name: 'All Monument',          glass: null,     alu: 'monument',    match: true, aluOnly: true,
      note: 'Monument on every aluminium fence' }
  ];
  var FIXINGS = [
    { id: 'base',   name: 'Bolted down',              note: 'Glass: Base Mount spigots. Aluminium: Base Mount posts.' },
    { id: 'ground', name: 'Set in concrete or ground', note: 'Glass: Core Drill spigots. Aluminium: In Ground posts.' },
    { id: 'each',   name: 'Different for each fence',  note: 'Pool coping one way, lawn the other.' }
  ];
  var SWATCH = { Mirror: 'linear-gradient(135deg,#f8fafc,#94a3b8 45%,#e2e8f0 60%,#64748b)',
                 Black: '#1f2124', White: '#ffffff', 'satin-black': '#2a2c2f', monument: '#4f5357' };
  var SWATCH_NAME = { Mirror: 'Mirror stainless', Black: 'Black', White: 'White',
                      'satin-black': 'Satin Black', monument: 'Monument' };

  /* A fence counts as priced only when it has a real total — not just a $0 pickup or tax line
     (break test F2: a blank calculator had two $0 lines and was saved into the job as $0.00). */
  function isPriced(gc) {
    try {
      var t = (gc && gc.state && gc.state.quoteBreakdown || []).reduce(function (s, b) { return s + (Number(b.totalPrice) || 0); }, 0);
      return t > 0;
    } catch (e) { return false; }
  }

  function log() { try { console.log.apply(console, ['[cf-job-ui]'].concat([].slice.call(arguments))); } catch (e) {} }
  function money(n) {
    return '$' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function path() { return String(location.pathname || '').replace(/\/+$/, '') || '/'; }
  function currentCalc() {
    var p = path(), out = null;
    Object.keys(PATHS).forEach(function (k) { if (PATHS[k] === p) out = k; });
    return out;
  }
  function onQuotePage() { return path().indexOf(QUOTE_PAGE) === 0; }
  function calcInstance() {
    try { return window.glassCalculator || window.glassFencingCalculator || null; } catch (e) { return null; }
  }
  /* A tile can start a mixed job before any fence exists ("?job=new"), and step 1's
     question can start one too. The intent is what makes the strip and the look picker
     appear while the job still has no runs in it. */
  function setMixIntent(on) {
    try {
      var j = J.state();
      j.mixIntent = !!on;
      J.save(j);
    } catch (e) {}
  }
  function mixIntent() {
    try { return jobActive() && !!J.state().mixIntent; } catch (e) { return false; }
  }

  /* The one colour per fence the strip already used for its chips; the "+ Add section"
     popover reuses it so a fence is the same colour everywhere in the job. */
  function fenceColour(ct) {
    return ct === 'Frameless' ? '#4ade80' : ct === 'PerfMesh' ? '#a16207' : ct === 'Blade' ? '#64748b' : '#94a3b8';
  }

  function lookById(id) {
    for (var i = 0; i < LOOKS.length; i++) if (LOOKS[i].id === id) return LOOKS[i];
    return null;
  }

  /* ── PLAN (2026-09-24) — a fence type per section, chosen at Add Sections ────────
     Pete, 24 Sep: "if we are doing mixed fences, it should be chosen at the add
     sections." The customer sets a fence type for EVERY section, right where they set
     how many sections there are — not after building a whole fence and finding "+
     Another fence type" afterwards. cf-job.js stores the resulting PLAN (an ordered
     list of {planNum, calcType, lengthMm}); everything below reads and writes it and
     presses each calculator's own controls to act on it. Nothing here edits a
     calculator, and none of it runs unless the customer answers "No, I will mix". */

  function setPlanPrefillFor(calcType, opts) {
    try {
      var items = J.planItemsForCalc(calcType);
      if (!items.length) return false;
      sessionStorage.setItem(PLAN_PREFILL_KEY, JSON.stringify({
        calcType: calcType,
        items: items.map(function (it) { return { planNum: it.planNum, lengthMm: it.lengthMm }; }),
        at: Date.now(),
        reopen: !!(opts && opts.reopen)
      }));
      return true;
    } catch (e) { return false; }
  }

  /* Sets THIS calculator's own section count and every one of its section's lengths
     from the plan, pressing the real controls exactly as the customer would: the count
     select, the real "Next →" into Configure Sections, then each #section-N-length. A
     short poll, not a fixed wait, because the count's own change handler has to run
     first before the length fields exist. `items` is this calc's own plan rows, in
     plan order — item i belongs to this calc's local Section (i+1). */
  function runPlanPrefill(items, cb) {
    if (!items || !items.length) { if (cb) cb(false); return; }
    var tries = 0, stage = 'count', done = false;
    var iv = setInterval(function () {
      tries++;
      try {
        if (stage === 'count') {
          var sel = document.getElementById('sections-count');
          if (sel) {
            if (String(sel.value) === String(items.length)) { stage = 'mode'; }
            else if (setSelect(sel, String(items.length))) { stage = 'mode'; }
          }
        } else if (stage === 'mode') {
          /* 2026-09-26: a mixed job configures every section on its own page, so each
             calculator is put in its own "Configure each individually" mode BEFORE Next —
             that is what puts colour, fixing, height and hinges on every section's page. */
          forceIndividual(true);
          stage = 'next';
        } else if (stage === 'next') {
          /* The count's own change handler can build #section-N-length eagerly, hidden,
             before Configure Sections is the visible step — so EXISTENCE is not proof we
             are there. Only a field the customer could actually see means Next already
             landed; otherwise keep pressing it every tick until it does. */
          var already = document.getElementById('section-1-length');
          if (already && already.offsetParent !== null) { stage = 'lengths'; }
          else {
            var nb = document.getElementById('sections-next-btn');
            /* We are pressing this ourselves, on the customer's behalf, right after they
               told us their sections — it may be display:none because mix mode hides it
               from THEM (choose() above), but that must not stop US clicking it. */
            if (nb) { nb.style.display = ''; nb.click(); }
          }
        } else if (stage === 'lengths') {
          var ok = true;
          items.forEach(function (it, i) {
            var el = document.getElementById('section-' + (i + 1) + '-length');
            if (!el) { ok = false; return; }
            if (String(el.value) !== String(it.lengthMm)) {
              el.value = it.lengthMm;
              el.dispatchEvent(new Event('input', { bubbles: true }));
              el.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          if (ok) { stage = 'done'; done = true; clearInterval(iv); if (cb) cb(true); }
        }
      } catch (e) { log('runPlanPrefill step failed', stage, e); }
      if (!done && tries > 30) { clearInterval(iv); log('runPlanPrefill gave up at', stage); if (cb) cb(false); }
    }, 400);
  }

  function planNumsAndLengths(items) {
    var nums = items.map(function (it) { return it.planNum; });
    var numsTxt = nums.length > 1
      ? ('sections ' + nums.slice(0, -1).join(', ') + ' and ' + nums[nums.length - 1])
      : ('section ' + nums[0]);
    var lens = items.map(function (it) { return (Number(it.lengthMm) / 1000).toFixed(1) + ' m'; }).join(', ');
    return numsTxt + ' (' + lens + ')';
  }

  /* The one-line arrival banner: "Now PerfMesh: sections 2 and 5 (12.0 m, 6.4 m). Then
     review the whole job." — or, reopening an earlier fence from the strip, the honest
     version of what came back. */
  function showPlanBanner(items, isLast, reopen) {
    try {
      var old = document.getElementById('cf-job-plan-banner');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var here = currentCalc();
      var fenceName = FENCE[here] || 'this fence';
      var b = document.createElement('div');
      b.className = 'cf-jb-banner';
      b.id = 'cf-job-plan-banner';
      var line;
      var tags = items.map(function (it) { return (SHORT[here] || fenceName) + ' S' + it.planNum; }).join(', ');
      if (reopen) {
        line = 'Back on ' + fenceName + ' (' + tags + '), just as you left it.';
      } else {
        line = 'Now ' + fenceName + ': ' + planNumsAndLengths(items) + '. Your job choices are already set on '
          + (items.length > 1 ? 'each section' : 'this section') + ' — check the options, then '
          + (isLast ? 'review the whole job.' : 'carry on to the next fence type.');
      }
      b.textContent = line;
      var host = document.querySelector('.calculator-tabs') || document.querySelector('.calculator-layout');
      if (host && host.parentNode) host.parentNode.insertBefore(b, host);
    } catch (e) { log('showPlanBanner failed', e); }
  }

  /* The summary under the sections (work-order item 2): "Sections 1 and 3: Frameless
     Glass (this page). Section 2: PerfMesh (next)." Rebuilt every tick; cheap and
     idempotent, same pattern as the strip. */
  function renderPlanSummary() {
    try {
      var old = document.getElementById('cf-job-plan-summary');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var plan = J.getPlan();
      var here = currentCalc();
      if (!plan || !here) return;
      if (document.getElementById('cf-job-tabs')) return;   // the job tabs say it better (2026-09-26)
      var order = J.planCalcOrder();
      var have = {};
      J.includedQuotes().forEach(function (q) { have[q.calcType] = true; });
      var byType = {};
      plan.items.forEach(function (it) { (byType[it.calcType] = byType[it.calcType] || []).push(it.planNum); });
      var parts = [];
      order.forEach(function (ct) {
        var nums = (byType[ct] || []).slice().sort(function (a, b) { return a - b; });
        if (!nums.length) return;
        var word = nums.length === 1 ? ('Section ' + nums[0])
          : ('Sections ' + nums.slice(0, -1).join(', ') + ' and ' + nums[nums.length - 1]);
        var status = (ct === here) ? ' (this page)' : (have[ct] ? ' (done)' : ' (next)');
        parts.push(word + ': ' + (FENCE[ct] || ct) + status);
      });
      if (!parts.length) return;
      var wrap = document.createElement('div');
      wrap.id = 'cf-job-plan-summary';
      wrap.className = 'cf-jb-summary';
      wrap.textContent = parts.join('. ') + '.';
      var host = document.getElementById('section-tabs-container') || document.querySelector('.section-tabs');
      if (host && host.parentNode) { host.parentNode.insertBefore(wrap, host.nextSibling); return; }
      var h2 = stripHost();
      if (h2) h2.el.parentNode.insertBefore(wrap, h2.where === 'before' ? h2.el : h2.el.nextSibling);
    } catch (e) { log('renderPlanSummary failed', e); }
  }

  /* On arrival (a hop, or a chip re-opening an earlier fence): apply whatever plan
     prefill is waiting for THIS page, once, then say so. */
  var planPrefillInFlight = false;

  function readFresh(key) {
    var v = null;
    try { v = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (v && v.at && (Date.now() - Number(v.at)) > 120000) { try { sessionStorage.removeItem(key); } catch (e) {} return null; }
    return v;
  }

  /* 2026-09-26: going BACK to a fence restores it exactly as it was left. cf-calc-memory.js
     already snapshots every control on a calculator page (colour, fixing, gates, hinges…);
     cf-fresh-start.js used to move that snapshot aside on every visit, which is why glass
     came back Mirror / Core Drill after the customer had chosen Black / Base Mount.
     'cf-job-arrive' now tells it to leave the snapshot alone, and this waits for the
     restore to finish before touching anything. */
  function whenMemorySettled(cb) {
    var n = 0;
    var iv = setInterval(function () {
      n++;
      var st = window.__cfCalcMemoryState;
      if (st === 'done' || st === 'failed' || (st === 'none' && n > 3) || n > 80) {
        clearInterval(iv);
        setTimeout(cb, 600);
      }
    }, 300);
  }

  function goStep(id) {
    try {
      var pane = document.getElementById(id);
      if (pane && pane.classList.contains('active')) return;
      var t = document.querySelector('.calculator-tabs [data-tab="' + id + '"]');
      if (t) t.click();
    } catch (e) {}
  }

  function openGotoSection() {
    try {
      var g = readFresh(GOTO_KEY);
      if (!g || g.calcType !== currentCalc()) return;
      try { sessionStorage.removeItem(GOTO_KEY); } catch (e) {}
      var gc = calcInstance();
      var n = parseInt(g.local, 10) || 1;
      goStep('configure-sections');
      setTimeout(function () {
        try { if (gc && gc.state && n <= (gc.state.sectionsCount || 0)) gc.showSection(n); } catch (e) {}
        renderJobTabs();
      }, 400);
    } catch (e) {}
  }

  function checkPlanPrefill() {
    try {
      var here = currentCalc();
      var arrive = readFresh(ARRIVE_KEY);
      var mode = (arrive && arrive.path === PATHS[here]) ? arrive.mode : null;
      if (mode) { try { sessionStorage.removeItem(ARRIVE_KEY); } catch (e) {} }

      var raw = readFresh(PLAN_PREFILL_KEY);
      if (raw && raw.calcType !== here) raw = null;
      if (raw) { try { sessionStorage.removeItem(PLAN_PREFILL_KEY); } catch (e) {} }
      /* 2026-09-26 (break test F5): opened from the menu or a bookmark, with nothing to restore —
         a fence that is part of the job still gets the sections and lengths its plan gave it. */
      if (!raw && !mode && J.getPlan() && J.planItemsForCalc(here).length) {
        var planned = J.planItemsForCalc(here).map(function (it) { return { planNum: it.planNum, lengthMm: it.lengthMm }; });
        whenMemorySettled(function () {
          var f = document.getElementById('section-1-length');
          if (window.__cfCalcMemoryState === 'done' || (f && f.value)) { openGotoSection(); return; }
          planPrefillInFlight = true;
          runPlanPrefill(planned, function () {
            planPrefillInFlight = false;
            showPlanBanner(planned, !J.planNextCalc(here), false);
            renderStrip(); renderJobTabs(); openGotoSection();
          });
        });
        return;
      }
      if (!raw && mode !== 'resume') { openGotoSection(); return; }

      /* While this is running, hold off rendering the "Will every section be…?" question
         on top of it — it would flash the mix rows for a moment before the real prefill
         silently advances the step, which reads as broken even though nothing is. */
      planPrefillInFlight = true;
      var after = function (ok) {
        planPrefillInFlight = false;
        if (raw) {
          var isLast = !J.planNextCalc(here);
          showPlanBanner(raw.items, isLast, mode === 'resume' || raw.reopen);
        }
        renderPlanSummary();
        renderStrip();
        openGotoSection();
        log('arrival', mode || 'fresh', ok ? 'applied' : 'incomplete', raw && raw.items);
      };
      if (mode === 'resume') {
        whenMemorySettled(function () {
          goStep('configure-sections');
          /* The plan may have changed while they were away (a section added from another
             fence's page): the prefill only presses what differs, so an unchanged fence is
             left exactly as restored. */
          setTimeout(function () { if (raw) runPlanPrefill(raw.items, after); else after(true); }, 900);
        });
      } else {
        runPlanPrefill(raw.items, after);
      }
    } catch (e) { planPrefillInFlight = false; log('checkPlanPrefill failed', e); }
  }

  /* ── the Add Sections rows (fence type + length per section) ────────────────── */

  function planRowsHost() {
    return document.getElementById('cf-job-plan-rows');
  }

  function renderPlanRows(wrap) {
    var sel = document.getElementById('sections-count');
    var n = sel ? (parseInt(sel.value, 10) || 0) : 0;
    var here = currentCalc();
    var old = planRowsHost();
    var prev = [];
    if (old) {
      [].slice.call(old.querySelectorAll('.cf-jb-row')).forEach(function (r) {
        var lenEl = r.querySelector('.cf-jb-row__len'), typeEl = r.querySelector('.cf-jb-row__type');
        prev.push({ len: lenEl ? lenEl.value : '', type: typeEl ? typeEl.value : here });
      });
      old.parentNode.removeChild(old);
    }
    if (!n) return;
    var rows = document.createElement('div');
    rows.id = 'cf-job-plan-rows';
    rows.className = 'cf-jb-rows';
    for (var i = 0; i < n; i++) {
      var row = document.createElement('div');
      row.className = 'cf-jb-row';
      var num = document.createElement('span');
      num.className = 'cf-jb-row__num';
      num.textContent = 'Section ' + (i + 1);
      var len = document.createElement('input');
      len.type = 'text';
      len.inputMode = 'numeric';
      len.autocomplete = 'off';
      len.placeholder = 'Length (mm)';
      len.className = 'cf-jb-row__len';
      len.value = prev[i] ? prev[i].len : '';
      var typeSel = document.createElement('select');
      typeSel.className = 'cf-jb-row__type';
      Object.keys(PATHS).forEach(function (ct) {
        var opt = document.createElement('option');
        opt.value = ct;
        opt.textContent = FENCE[ct] + (ct === here ? ' (this page)' : '');
        typeSel.appendChild(opt);
      });
      typeSel.value = prev[i] ? prev[i].type : here;
      row.appendChild(num); row.appendChild(len); row.appendChild(typeSel);
      rows.appendChild(row);
    }
    wrap.appendChild(rows);
  }

  function buildPlanFromRows() {
    var host = planRowsHost();
    if (!host) return null;
    var rows = [].slice.call(host.querySelectorAll('.cf-jb-row'));
    var items = [], bad = false;
    rows.forEach(function (r, i) {
      var lenEl = r.querySelector('.cf-jb-row__len'), typeEl = r.querySelector('.cf-jb-row__type');
      var mm = parseFloat(lenEl.value);
      if (!mm || mm <= 0) { bad = true; lenEl.style.borderColor = '#dc2626'; }
      else { lenEl.style.borderColor = ''; }
      items.push({ planNum: i + 1, calcType: typeEl.value, lengthMm: mm || 0 });
    });
    return bad ? null : items;
  }

  /* The customer pressed Continue on the mix rows: save the plan, then either design
     THIS calculator's own sections (prefilled from what they just typed) or, if none of
     the sections are this fence, go straight to the fence that owns the first one — this
     calculator has nothing to design and nothing to save. */
  function onPlanContinue(errEl) {
    var items = buildPlanFromRows();
    if (!items) {
      if (errEl) errEl.style.display = 'block';
      return;
    }
    if (errEl) errEl.style.display = 'none';
    J.savePlan(items);
    var here = currentCalc();
    var mine = J.planItemsForCalc(here);
    if (!mine.length) {
      var nextCT = J.planNextCalc(null);
      if (nextCT && nextCT !== here) {
        hopScreen('Opening the ' + (FENCE[nextCT] || 'next') + ' calculator…', 'None of this job’s sections are ' + (FENCE[here] || 'this fence') + '.');
        setTimeout(function () { goToFence(nextCT, 1); }, 500);
      }
      return;
    }
    planPrefillInFlight = true;
    runPlanPrefill(mine.map(function (it) { return { planNum: it.planNum, lengthMm: it.lengthMm }; }), function (ok) {
      planPrefillInFlight = false;
      renderPlanSummary();
      renderStrip();
      log('own sections prefilled from plan', ok, mine);
    });
  }

  /* ── CSS ───────────────────────────────────────────────────────────────────── */

  var CSS = [
    '.cf-jb{position:relative;margin:14px 0;background:#0f172a;color:#fff;border-radius:10px;',
    'padding:10px 12px;display:flex;flex-wrap:wrap;gap:8px;align-items:center;',
    'font-family:inherit;font-size:13px;line-height:1.3}',
    '.cf-jb__lab{font-size:10.5px;letter-spacing:.11em;text-transform:uppercase;color:#94a3b8;font-weight:700;margin-right:2px}',
    '.cf-jb__run{display:inline-flex;gap:7px;align-items:center;background:#1e293b;border:1px solid #334155;',
    'border-radius:999px;padding:5px 11px;color:#fff;font-size:12.5px;font-weight:500;cursor:pointer}',
    '.cf-jb__run:hover{border-color:#64748b}',
    '.cf-jb__run.is-here{border-color:#22c55e;box-shadow:0 0 0 2px rgba(34,197,94,.25);cursor:default}',
    '.cf-jb__dot{width:10px;height:10px;border-radius:2px;display:inline-block;flex:none}',
    '.cf-jb__tot{margin-left:auto;font-weight:700;font-size:14px;white-space:nowrap}',
    '.cf-jb__btn{background:#22c55e;color:#052e16;border:0;border-radius:6px;padding:7px 11px;',
    'font:inherit;font-weight:700;font-size:12.5px;cursor:pointer}',
    '.cf-jb__btn--ghost{background:transparent;color:#e2e8f0;border:1px solid #475569;font-weight:600}',
    '.cf-jb__btn:focus-visible,.cf-jb__run:focus-visible{outline:3px solid #7dd3fc;outline-offset:2px}',
    '.cf-jb__look{display:inline-flex;gap:7px;align-items:center;background:transparent;border:1px dashed #475569;',
    'border-radius:999px;padding:5px 11px;color:#e2e8f0;font:inherit;font-size:12.5px;cursor:pointer}',
    '.cf-jb__warn{flex-basis:100%;background:#7c2d12;border-radius:6px;padding:7px 10px;font-size:12.5px;',
    'display:flex;gap:10px;align-items:center;flex-wrap:wrap}',
    '.cf-jb__warn button{background:#fed7aa;color:#7c2d12;border:0;border-radius:5px;padding:4px 9px;font:inherit;font-weight:700;cursor:pointer}',
    '.cf-jb__menu{position:absolute;z-index:40;background:#fff;color:#111827;border:1px solid #cbd5e1;',
    'border-radius:8px;box-shadow:0 14px 34px -14px rgba(0,0,0,.45);padding:6px;min-width:250px}',
    '.cf-jb__menu b{display:block;font-size:10.5px;text-transform:uppercase;letter-spacing:.08em;color:#6b7280;padding:7px 10px 3px}',
    '.cf-jb__menu button{display:block;width:100%;text-align:left;background:none;border:0;border-radius:6px;',
    'padding:9px 10px;font:inherit;font-size:13px;color:#111827;cursor:pointer}',
    '.cf-jb__menu button:hover{background:#f1f5f9}',
    '.cf-jb-panel{position:fixed;inset:0;z-index:2147483000;background:rgba(15,23,42,.55);display:flex;',
    'align-items:center;justify-content:center;padding:16px}',
    '.cf-jb-panel__box{background:#fff;color:#111827;border-radius:12px;max-width:620px;width:100%;',
    'max-height:88vh;overflow:auto;padding:20px;font-size:14px}',
    '.cf-jb-panel h3{margin:0 0 4px;font-size:19px}',
    '.cf-jb-panel p.sub{margin:0 0 14px;color:#64748b;font-size:13px}',
    '.cf-jb-panel h4{margin:16px 0 8px;font-size:13px;text-transform:uppercase;letter-spacing:.07em;color:#374151}',
    '.cf-jb-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:8px}',
    '.cf-jb-card{border:2px solid #e2e8f0;border-radius:10px;background:#fff;padding:10px;text-align:left;',
    'font:inherit;cursor:pointer;display:flex;flex-direction:column;gap:6px;color:#111827}',
    '.cf-jb-card.on{border-color:#059669;box-shadow:0 0 0 3px rgba(5,150,105,.18)}',
    '.cf-jb-card small{color:#64748b;font-size:11.5px;line-height:1.35}',
    '.cf-jb-sw{display:flex;height:24px;border-radius:6px;overflow:hidden;border:1px solid #cbd5e1}',
    '.cf-jb-sw i{flex:1}',
    '.cf-jb-tag{align-self:flex-start;font-size:10px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;',
    'border-radius:999px;padding:2px 7px;background:#dcfce7;color:#166534}',
    '.cf-jb-tag.near{background:#fef3c7;color:#92400e}',
    '.cf-jb-panel__foot{display:flex;gap:8px;justify-content:flex-end;margin-top:18px}',
    '.cf-jb-panel__foot button{border-radius:8px;padding:9px 14px;font:inherit;font-weight:600;cursor:pointer}',
    '.cf-jb-done{background:#059669;color:#fff;border:0}',
    '.cf-jb-cancel{background:#fff;color:#374151;border:1px solid #cbd5e1}',
    '.cf-jb-hop{position:fixed;inset:0;z-index:2147483000;background:#0f172a;color:#fff;display:flex;',
    'flex-direction:column;align-items:center;justify-content:center;gap:10px;font-size:17px;text-align:center;padding:24px}',
    '.cf-jb-hop small{color:#94a3b8;font-size:13px}',
    /* Door B — the step-1 question, dressed like the calculator's own
       "Are all sections the same?" control so it reads as part of the form. */
    '.cf-jb-ask{margin-top:16px}',
    '.cf-jb-ask__lab{font-size:14px;font-weight:600;color:#374151;display:block;margin-bottom:8px}',
    '.cf-jb-ask__row{display:flex;gap:0;border:2px solid #e2e8f0;border-radius:8px;overflow:hidden;max-width:460px}',
    '.cf-jb-ask__row button{flex:1;padding:11px 8px;background:#fff;border:0;font:inherit;font-size:13px;',
    'font-weight:600;color:#475569;cursor:pointer}',
    '.cf-jb-ask__row button.on{background:#e8f6ee;color:#065f46;box-shadow:inset 0 0 0 2px #059669}',
    '.cf-jb-ask__row button:focus-visible{outline:3px solid #0e9ed5;outline-offset:-3px}',
    '.cf-jb-ask__note{display:none;font-size:12.5px;color:#475569;margin-top:8px;line-height:1.5;max-width:520px}',
    '.cf-jb-ask.is-mixed .cf-jb-ask__note{display:block}',
    '.cf-jb-banner{background:#0f172a;color:#fff;border-radius:10px;padding:12px 14px;margin:16px 0;',
    'font-size:14px;line-height:1.45}',
    '.cf-jb-banner b{display:block;font-size:15px;margin-bottom:2px}',
    '.cf-jb__more{display:none;background:transparent;border:1px solid #475569;color:#e2e8f0;',
    'border-radius:999px;padding:5px 11px;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer}',
    /* PLAN rows (2026-09-24) — the fence-type-per-section choice at Add Sections */
    '.cf-jb-ask .cf-jb-rows,.cf-jb-ask .cf-jb-plan-continue,.cf-jb-ask .cf-jb-plan-err{display:none}',
    '.cf-jb-ask.is-mixed .cf-jb-rows,.cf-jb-ask.is-mixed .cf-jb-plan-continue{display:block}',
    '.cf-jb-rows{margin-top:14px;display:flex;flex-direction:column;gap:8px;max-width:560px}',
    '.cf-jb-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}',
    '.cf-jb-row__num{flex:0 0 74px;font-size:12.5px;font-weight:700;color:#374151}',
    '.cf-jb-row__len{flex:1 1 110px;min-width:100px;padding:9px 10px;border:1.5px solid #cbd5e1;border-radius:7px;font:inherit;font-size:13px}',
    '.cf-jb-row__type{flex:1.4 1 160px;min-width:150px;padding:9px 8px;border:1.5px solid #cbd5e1;border-radius:7px;font:inherit;font-size:13px;background:#fff}',
    '.cf-jb-plan-continue{margin-top:12px;background:#0b3d20;color:#fff;border:0;border-radius:8px;',
    'padding:10px 16px;font:inherit;font-weight:700;font-size:13.5px;cursor:pointer}',
    '.cf-jb-plan-err{display:block;color:#b91c1c;font-size:12.5px;margin-top:6px}',
    '.cf-jb-summary{margin:10px 0;padding:9px 12px;background:#f1f5f9;border-radius:8px;',
    'font-size:12.5px;color:#334155;line-height:1.5}',
    /* "+ Add section" popover (2026-09-24, coordinator revision) — the fence-type choice
       for a section added mid-design, styled like the calculator's own pill buttons. */
    /* v2 (2026-09-25): full-width 44px rows, 15px text, the brand-green outline of the
       calculator's own "+ Add section" (#059669, 1px, 6px radius, white, weight 600). */
    '.cf-jb-addsec-pop{position:absolute;z-index:2147483000;background:#fff;border:1px solid #cbd5e1;',
    'border-radius:10px;box-shadow:0 14px 34px -14px rgba(0,0,0,.45);padding:12px;width:320px;box-sizing:border-box;',
    'color:#111827;font-size:15px}',
    '.cf-jb-addsec-pop *{box-sizing:border-box}',
    '.cf-jb-addsec-pop__head{display:flex;align-items:center;justify-content:space-between;gap:10px;',
    'margin-bottom:10px}',
    '.cf-jb-addsec-pop__head span{font-size:15px;font-weight:700;color:#111827}',
    '.cf-jb-addsec-pop__x{background:none;border:0;font-size:24px;line-height:1;color:#6b7280;',
    'cursor:pointer;width:36px;height:36px;border-radius:6px;flex:none}',
    '.cf-jb-addsec-pop__x:hover{background:#f1f5f9}',
    '.cf-jb-addsec-pop__x:focus-visible{outline:3px solid #7dd3fc;outline-offset:1px}',
    '.cf-jb-addsec-pop__body{display:flex;flex-direction:column;gap:8px}',
    '.cf-jb-addsec-choice{display:flex;align-items:center;gap:10px;width:100%;min-height:44px;margin:0;',
    'padding:10px 14px;background:#fff;color:#059669;border:1px solid #059669;border-radius:6px;',
    'font:inherit;font-size:15px;font-weight:600;line-height:1.25;text-align:left;cursor:pointer;',
    '-webkit-appearance:none;appearance:none;transition:background .12s,color .12s}',
    '.cf-jb-addsec-choice:hover{background:#ecfdf5}',
    '.cf-jb-addsec-choice:active{background:#059669;color:#fff}',
    '.cf-jb-addsec-choice:focus-visible{outline:3px solid #7dd3fc;outline-offset:2px}',
    '.cf-jb-addsec-choice .cf-jb__dot{width:12px;height:12px;border-radius:3px;border:1px solid rgba(0,0,0,.12)}',
    '.cf-jb-addsec-choice small{margin-left:auto;font-size:13px;font-weight:500;color:#047857;opacity:.85}',
    '.cf-jb-addsec-choice:active small{color:#fff}',
    '.cf-jb-addsec-pop__lab{display:block;font-size:15px;color:#374151;margin-bottom:2px}',
    '.cf-jb-addsec-pop__row{display:flex;gap:8px}',
    '.cf-jb-addsec-pop__row .cf-jb-row__len{flex:1;min-width:0;margin:0;height:44px;font-size:15px}',
    '.cf-jb-addsec-pop__row .cf-jb__btn{flex:none;height:44px;padding:0 18px;font-size:15px;background:#059669;color:#fff}',
    /* 2026-09-26 — job choices card, job section tabs, mixed-job step-1 chrome. */
    '.cf-jc{margin-top:16px;border:1px solid #cbd5e1;border-radius:10px;padding:14px;background:#f8fafc;max-width:560px}',
    '.cf-jb-ask .cf-jc--ask{display:none}.cf-jb-ask.is-mixed .cf-jc--ask{display:block}',
    '.cf-jc__h{font-size:15px;font-weight:700;color:#111827}',
    '.cf-jc__p{margin:2px 0 10px;font-size:12.5px;color:#475569;line-height:1.45}',
    '.cf-jc-row{margin-top:10px}',
    '.cf-jc-row__t{font-size:13px;font-weight:600;color:#374151;margin-bottom:6px}',
    '.cf-jc-seg{display:flex;flex-wrap:wrap;gap:6px}',
    '.cf-jc-opt{display:inline-flex;align-items:center;gap:7px;flex-wrap:wrap;min-height:40px;padding:8px 12px;',
    'border:1.5px solid #cbd5e1;border-radius:8px;background:#fff;color:#1f2937;font:inherit;font-size:13.5px;',
    'font-weight:600;cursor:pointer;text-align:left}',
    '.cf-jc-opt small{flex-basis:100%;font-size:11.5px;font-weight:500;color:#64748b}',
    '.cf-jc-opt.on{border-color:#059669;background:#ecfdf5;color:#065f46;box-shadow:inset 0 0 0 1px #059669}',
    '.cf-jc-opt:focus-visible{outline:3px solid #7dd3fc;outline-offset:2px}',
    '.cf-jc-sw{width:16px;height:16px;border-radius:4px;border:1px solid rgba(0,0,0,.2);display:inline-block;flex:none}',
    '.cf-jt{display:flex;flex-wrap:wrap;gap:8px;margin:4px 0 10px}',
    '.cf-jt__tab{display:inline-flex;align-items:center;gap:7px;min-height:42px;padding:8px 16px;border-radius:6px;',
    'font:inherit;font-size:16px;font-weight:600;cursor:pointer;border:1px solid #1f6f3a;background:#fff;color:#1f6f3a}',
    '.cf-jt__tab.is-active{background:#1f6f3a;color:#fff}',
    '.cf-jt__tab.is-away{border-style:dashed;color:#334155;border-color:#94a3b8}',
    '.cf-jt__tab small{font-size:13px;opacity:.8}',
    '.cf-jt__tab:focus-visible{outline:3px solid #7dd3fc;outline-offset:2px}',
    '.cf-jt__wrap{display:inline-flex;align-items:stretch;gap:0}',
    '.cf-jt__wrap .cf-jt__tab{border-top-right-radius:0;border-bottom-right-radius:0}',
    '.cf-jt__x{min-width:40px;min-height:42px;border:1px solid #cbd5e1;border-left:0;background:#fff;color:#64748b;font-size:20px;line-height:1;border-radius:0 6px 6px 0;cursor:pointer}',
    '.cf-jt__x:hover{background:#fef2f2;color:#b91c1c}',
    '.cf-jt{align-items:center}',
    '.cf-jt__lab{font-size:14px;font-weight:700;color:#334155;margin-right:2px}',
    '.cf-jt__more{min-height:42px;padding:0 14px;border:1px dashed #059669;border-radius:6px;background:#fff;color:#047857;font:inherit;font-size:14px;font-weight:600;cursor:pointer}',
    '.cf-jt__more:hover{background:#ecfdf5}',
    '@media (max-width:640px){.cf-jt__lab{flex:1 1 100%}}',
    '.cf-jt__wrap.is-asking{align-items:center;gap:8px;padding:4px 8px;border:1px solid #fca5a5;border-radius:6px;background:#fef2f2;font-size:14px}',
    '.cf-jt__yes{min-height:36px;padding:0 12px;border:0;border-radius:6px;background:#b91c1c;color:#fff;font:inherit;font-weight:700;cursor:pointer}',
    '.cf-jt__no{min-height:36px;padding:0 12px;border:1px solid #cbd5e1;border-radius:6px;background:#fff;color:#111827;font:inherit;font-weight:600;cursor:pointer}',
    '.cf-jb-gap{background:#7c2d12}.cf-jb-gap b{color:#fff}',
    '.cf-planner{max-width:760px;margin:24px auto;padding:20px 22px;background:#fff;border:1px solid #cbd5e1;border-radius:12px;box-shadow:0 10px 30px -18px rgba(0,0,0,.35);font-family:inherit;color:#111827}',
    '.cf-planner h2{margin:0 0 6px;font-size:24px}',
    '.cf-planner__p{margin:0 0 14px;color:#475569;font-size:14.5px;line-height:1.5}',
    '.cf-planner .cf-jb-row{flex-wrap:nowrap}',
    '.cf-planner .cf-jb-row__len,.cf-planner .cf-jb-row__type{min-height:44px;font-size:15px}',
    '.cf-planner__x{flex:none;width:40px;height:40px;border:1px solid #cbd5e1;border-radius:8px;background:#fff;color:#64748b;font-size:20px;cursor:pointer}',
    '.cf-planner__add{margin:10px 0 0;min-height:40px;padding:0 14px;border:1px solid #059669;border-radius:8px;background:#fff;color:#047857;font:inherit;font-weight:600;cursor:pointer}',
    '.cf-planner__go{display:block!important;margin-top:16px;min-height:46px;font-size:15px}',
    '.cf-planner .cf-planner__sec{display:block;border:1px solid #e2e8f0;border-radius:10px;padding:12px 14px;background:#f8fafc}',
    '.cf-planner__rows{gap:12px}',
    '.cf-planner__resume{margin:0 0 14px;padding:10px 12px;border:1px solid #fcd34d;border-radius:8px;background:#fffbeb;font-size:14px;color:#78350f;line-height:1.6}',
    '.cf-planner__resume-btn{min-height:34px;padding:0 12px;border:1px solid #059669;border-radius:7px;background:#fff;color:#047857;font:inherit;font-weight:700;cursor:pointer}',
    '.cf-planner__head{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '.cf-planner__head .cf-jb-row__num{flex:none;font-size:15px;color:#111827}',
    '.cf-planner__q{margin:4px 0 10px;font-size:15px;font-weight:600;color:#111827}',
    '.cf-planner .cf-planner__sec select.cf-jb-row__type{display:none}',
    '.cf-planner__tiles{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;border-radius:10px}',
    '.cf-planner__tile{display:flex;flex-direction:column;align-items:stretch;gap:6px;padding:6px 6px 8px;border:2px solid #cbd5e1;border-radius:10px;background:#fff;color:#111827;font:inherit;font-size:14px;font-weight:600;cursor:pointer;text-align:center;min-height:48px;justify-content:center}',
    '.cf-planner__tile img{display:block;width:100%;height:78px;object-fit:cover;border-radius:6px}',
    '@media (hover:hover){.cf-planner__tile:hover{border-color:#059669}}',
    '.cf-planner__tile.is-on{border-color:#059669;background:#ecfdf5;box-shadow:0 0 0 2px #05966933}',
    '.cf-planner__tile.is-on span:before{content:"\\2713  ";color:#047857}',
    '.cf-planner__tiles.is-picked .cf-planner__tile:not(.is-on){opacity:.7}',
    '.cf-planner__len{display:flex;align-items:center;gap:10px;margin:12px 0 0;flex-wrap:wrap}',
    '.cf-planner__len>span:first-child{font-size:15px;font-weight:600;color:#111827}',
    '.cf-planner__lenbox{display:flex;align-items:center;gap:8px;flex:0 1 240px;min-width:0}',
    '.cf-planner__len .cf-jb-row__len{flex:1 1 auto;width:auto;min-width:0;min-height:44px;font-size:15px}',
    '.cf-planner__mm{color:#475569;font-size:14px}',
    '@media (max-width:640px){.cf-planner__tiles{grid-template-columns:repeat(2,minmax(0,1fr))}.cf-planner__tile img{height:64px}.cf-planner__lenbox{flex:1 1 100%}}',
    '@media (max-width:640px){.cf-planner{margin:12px 8px;padding:16px}.cf-planner .cf-jb-row{flex-wrap:wrap}.cf-planner .cf-jb-row__num{flex:1 1 auto}.cf-planner .cf-jb-row__len,.cf-planner .cf-jb-row__type{flex:1 1 100%}}',
    'html.cf-mixjob #add-mode-group{display:none!important}',
    'html.cf-mix-step1 #nav-next{display:none!important}',
    /* PHONE SECTION-BUTTON ROW (2026-09-25, Pete: "fix the phone next button"). All four
       calculators build #section-tabs-container > div as [tabs div, Next button.btn-primary],
       and cf-section-add-remove.js appends [+ Add section, Delete] as a third div.
       cf-mobile-polish.js (11 Sep) forces that into ONE non-wrapping row with Next pinned
       sticky on the right at 36px — so on a 375px phone Next sat on top of "+ Add section".
       This wraps it instead: section pills on the first line, Add/Delete next, Next at the
       end of that line when it fits, otherwise on its own full-width line. 40px targets.
       Phone only (the same 749px breakpoint); the ID outranks the polish rules, so desktop
       and every other page are untouched. Everyone's row — single fence or mixed. */
    '@media (max-width:749px){',
    'html body #section-tabs-container.section-tabs > div{display:flex!important;flex-wrap:wrap!important;',
    'overflow:visible!important;gap:8px!important;align-items:stretch!important;padding:2px 0 6px!important}',
    'html body #section-tabs-container.section-tabs > div > div:first-child{flex:1 1 100%!important;display:flex!important;',
    'flex-wrap:wrap!important;gap:8px!important;margin:0!important}',
    'html body #section-tabs-container.section-tabs > div > div:not(:first-child){flex:0 1 auto!important;display:flex!important;',
    'flex-wrap:wrap!important;gap:8px!important;margin:0!important;max-width:100%!important}',
    'html body #section-tabs-container.section-tabs button{height:auto!important;min-height:40px!important;',
    'padding:0 12px!important;font-size:15px!important;line-height:1.2!important;white-space:nowrap!important;',
    'box-sizing:border-box!important;margin:0!important}',
    'html body #section-tabs-container.section-tabs > div > button.btn-primary{order:99!important;flex:1 0 auto!important;',
    'position:static!important;margin:0!important;min-width:96px!important}',
    '}',
    '@media (max-width:640px){.cf-jb{font-size:12px}.cf-jb__tot{margin-left:auto;order:0}',
    '.cf-jb__run{font-size:11.5px;padding:4px 9px}',
    '.cf-jb__more{display:inline-block}',
    '.cf-jb.is-closed .cf-jb__run,.cf-jb.is-closed .cf-jb__look,.cf-jb.is-closed .cf-jb__btn--ghost{display:none}',
    '.cf-jb.is-closed .cf-jb__run.is-here{display:inline-flex}',
    '.cf-jb-row{flex-direction:column;align-items:stretch;gap:4px;border:1px solid #e2e8f0;border-radius:8px;padding:8px}',
    '.cf-jb-row__num{flex:none}.cf-jb-row__len,.cf-jb-row__type{flex:none;width:100%}',
    '.cf-jb-addsec-pop{left:8px !important;right:8px;width:auto;max-width:none !important}}'
  ].join('');

  function css() {
    if (document.getElementById('cf-job-ui-css')) return;
    var s = document.createElement('style');
    s.id = 'cf-job-ui-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ── restoring a run into its own calculator ───────────────────────────────── */

  /* Can this fence come back exactly as the customer left it? Only if this browser tab
     still holds its working snapshot AND that snapshot was made inside this job — an older,
     unrelated fence must never be "restored" into the middle of a new job. */
  function canResume(calcType) {
    try {
      var raw = sessionStorage.getItem('cf-calc:' + PATHS[calcType]) || sessionStorage.getItem('cf-fresh-hold:' + PATHS[calcType]);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      var born = Date.parse(J.state().createdAt) || 0;
      return !!(snap && snap.ts && snap.ts >= born);
    } catch (e) { return false; }
  }
  function setArrive(calcType) {
    var mode = canResume(calcType) ? 'resume' : 'fresh';
    try {
      /* A snapshot parked by cf-fresh-start on an earlier visit goes back where the memory reads it. */
      if (mode === 'resume' && !sessionStorage.getItem('cf-calc:' + PATHS[calcType])) {
        sessionStorage.setItem('cf-calc:' + PATHS[calcType], sessionStorage.getItem('cf-fresh-hold:' + PATHS[calcType]));
        sessionStorage.removeItem('cf-fresh-hold:' + PATHS[calcType]);
      }
      sessionStorage.setItem(ARRIVE_KEY, JSON.stringify({ path: PATHS[calcType], mode: mode, at: Date.now() }));
    } catch (e) {}
    return mode;
  }

  /* The one way to move to another fence's section: save this fence if it is priced (so
     it is in the job), then open that fence on the section asked for. */
  function goToFence(calcType, local) {
    try {
      if (!calcType || !PATHS[calcType]) return;
      try { sessionStorage.setItem(GOTO_KEY, JSON.stringify({ calcType: calcType, local: local || 1, at: Date.now() })); } catch (e) {}
      var gc = calcInstance(), priced = false;
      priced = isPriced(gc);
      if (currentCalc() && priced) { startHop(calcType); return; }
      setArrive(calcType);
      if (J.getPlan()) setPlanPrefillFor(calcType);
      window.location.href = PATHS[calcType];
    } catch (e) { log('goToFence failed', e); }
  }

  function openRun(run) {
    try {
      if (J.getPlan() && canResume(run.calcType)) { goToFence(run.calcType, 1); return; }
      var q = null, arr = [];
      try { arr = JSON.parse(localStorage.getItem(J.CALC_KEYS[run.calcType].quotes) || '[]') || []; } catch (e) {}
      for (var i = 0; i < arr.length; i++) if (Number(arr[i].quoteNum) === Number(run.quoteNum)) q = arr[i];
      if (q) {
        /* The calculators' own restore path: the payload in 'ullc_quote' plus their own
           return flag. Same keys they set for themselves when leaving the quote page. */
        sessionStorage.setItem('ullc_quote', JSON.stringify(q));
        sessionStorage.setItem(STORE_PREFIX[run.calcType] + '_quote_return', '1');
        localStorage.setItem(J.CALC_KEYS[run.calcType].active, String(run.quoteNum));
      }
      /* PLAN (2026-09-24) — item 7, "going back": the plan owns this run's section count
         and lengths, so re-apply them through the real controls on arrival — narrower
         than the phase-3 gap, because it restores real EDITABLE sections, not just a
         saved quote's Review step. Colour/gates/finish are not restored; the arrival
         banner says so honestly. */
      if (J.getPlan()) setPlanPrefillFor(run.calcType, { reopen: true });
      setArrive(run.calcType);
      window.location.href = PATHS[run.calcType] || QUOTE_PAGE;
    } catch (e) { log('openRun failed', e); }
  }

  /* ── the hop: save this fence, then open another fence's calculator ────────── */

  var REVIEW = '__review';

  function startHop(toCalcType) {
    var from = currentCalc();
    if (!from || !toCalcType) return;
    try {
      sessionStorage.setItem(HOP_KEY, JSON.stringify({ to: toCalcType, from: from, at: Date.now() }));
    } catch (e) {}
    /* PLAN (2026-09-24) — item 4, carry the customer on automatically: if the plan
       calls for sections on the fence we are hopping to, queue them for prefill so the
       next calculator opens with its own section count and every length already typed. */
    if (toCalcType !== REVIEW) { setPlanPrefillFor(toCalcType); setArrive(toCalcType); }

    hopScreen('Saving your ' + (FENCE[from] || 'fence') + '…',
      toCalcType === REVIEW ? 'Then we will show you the whole job.'
                            : 'Then we will open the ' + (FENCE[toCalcType] || 'next') + ' calculator.');

    var gc = calcInstance();
    try {
      if (gc && typeof gc.proceedToQuotePage === 'function') { gc.proceedToQuotePage(); return; }
    } catch (e) { log('proceedToQuotePage failed', e); }

    /* PerfMesh has no proceedToQuotePage — its own Add to Cart button saves the quote and
       goes to the quote page, which is exactly the same journey. */
    var btn = document.getElementById('add-to-cart');
    if (btn) { btn.__cfAllowed = true; try { btn.click(); } finally { btn.__cfAllowed = false; } return; }

    try { sessionStorage.removeItem(HOP_KEY); } catch (e) {}
    hopClear();
    alert('Please finish pricing this fence first, then continue.');
  }

  function hopScreen(title, sub) {
    hopClear();
    var d = document.createElement('div');
    d.className = 'cf-jb-hop';
    d.id = 'cf-jb-hop';
    var h = document.createElement('div'); h.textContent = title;
    var s = document.createElement('small'); s.textContent = sub || '';
    d.appendChild(h); d.appendChild(s);
    document.body.appendChild(d);
  }
  function hopClear() {
    var e = document.getElementById('cf-jb-hop');
    if (e && e.parentNode) e.parentNode.removeChild(e);
  }

  /* Runs on the quote page: the calculator has just saved, so file that quote into the
     job and send the customer on to the fence they asked for. */
  function finishHop() {
    var hop = null;
    try { hop = JSON.parse(sessionStorage.getItem(HOP_KEY) || 'null'); } catch (e) {}
    if (!hop || !hop.to) return false;
    try { sessionStorage.removeItem(HOP_KEY); } catch (e) {}

    /* A hop that never completed (the save failed, the customer went elsewhere) must not
       hijack a later visit to the quote page and bounce them into a calculator. Anything
       older than two minutes is stale and is simply dropped. */
    if (!hop.at || (Date.now() - Number(hop.at)) > 120000) {
      log('stale hop ignored', hop);
      return false;
    }

    try {
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(J.CALC_KEYS[hop.from].quotes) || '[]') || []; } catch (e) {}
      var newest = null;
      arr.forEach(function (q) {
        if (!q || !q.breakdown || !q.breakdown.length) return;
        if (!newest || (Date.parse(q.generatedAt) || 0) >= (Date.parse(newest.generatedAt) || 0)) newest = q;
      });
      /* 2026-09-26 (break test F2): a fence saved with nothing priced is never filed as a $0.00
         run — that is what made merge() refuse the job and the quote page silently fall back to
         ONE fence. Its earlier priced run (if any) stays in the job. */
      if (newest && !(Number(newest.grandTotal) > 0)) { log('hop: unpriced fence not filed', hop.from); newest = null; }
      if (newest) { if (J.getPlan() && J.replaceRun) J.replaceRun(hop.from, newest.quoteNum); else J.addRun(hop.from, newest.quoteNum); }
      J.setOn(true);
    } catch (e) { log('finishHop bookkeeping failed', e); }

    /* Asked for the whole job: this IS the page they wanted, so just stay here. */
    if (hop.to === REVIEW || !PATHS[hop.to]) { hopClear(); return false; }

    hopScreen('Opening the ' + (FENCE[hop.to] || 'next') + ' calculator…', 'Your other fence is saved in this job.');
    try { window.location.replace(PATHS[hop.to]); } catch (e) { window.location.href = PATHS[hop.to]; }
    return true;
  }

  /* ── the look, applied through each calculator's own controls ──────────────── */

  function press(el) {
    if (!el) return false;
    try { el.click(); return true; } catch (e) { return false; }
  }
  function setSelect(el, value) {
    if (!el || value == null) return false;
    var ok = false;
    for (var i = 0; i < el.options.length; i++) {
      if (String(el.options[i].value).toLowerCase() === String(value).toLowerCase()) { el.selectedIndex = i; ok = true; break; }
    }
    if (!ok) return false;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* What this calculator is showing right now, in look terms. */
  function readCurrent() {
    var calc = currentCalc();
    if (!calc) return null;
    if (calc === 'Frameless') {
      var col = document.getElementById('spigot-shape');
      var mnt = document.getElementById('spigot-type');
      return {
        colour: col && col.value ? col.value : null,
        fixing: mnt && mnt.value ? (/core/i.test(mnt.value) ? 'ground' : 'base') : null
      };
    }
    var on = document.querySelector('#shared-color-swatches [data-color].active, #shared-color-swatches [data-color][aria-checked="true"]');
    var checked = document.querySelector('input[name="shared-color"]:checked');
    var ground = document.getElementById('shared-mount-inground');
    return {
      colour: (checked && checked.value) || (on && on.getAttribute('data-color')) || null,
      fixing: ground ? (ground.checked ? 'ground' : 'base') : null
    };
  }

  function applyLook() {
    var job = J.state();
    var look = job.look ? lookById(job.look.id) : null;
    var calc = currentCalc();
    if (!calc || (!look && !job.fixing)) return;

    var wanted = { colour: null, fixing: null };
    if (look) wanted.colour = (calc === 'Frameless') ? look.glass : look.alu;
    if (job.fixing && job.fixing !== 'each') wanted.fixing = job.fixing;

    try {
      if (calc === 'Frameless') {
        if (wanted.colour) setSelect(document.getElementById('spigot-shape'), wanted.colour);
        if (wanted.fixing) setSelect(document.getElementById('spigot-type'), wanted.fixing === 'ground' ? 'Core Drill' : 'Base Mount');
        /* Sections already built carry their own copies of these controls. */
        [].slice.call(document.querySelectorAll('[id^="section-"][id$="-finish"]')).forEach(function (el) {
          if (wanted.colour) setSelect(el, wanted.colour);
        });
        [].slice.call(document.querySelectorAll('[id^="section-"][id$="-spigot-type"]')).forEach(function (el) {
          if (wanted.fixing) setSelect(el, wanted.fixing === 'ground' ? 'Core Drill' : 'Base Mount');
        });
      } else {
        if (wanted.colour) {
          var radio = document.querySelector('input[name="shared-color"][value="' + wanted.colour + '"]');
          if (radio && !radio.checked) press(radio.closest('label') || radio);
          if (!radio || !radio.checked) {
            var sw = document.querySelector('#shared-color-swatches [data-color="' + wanted.colour + '"], .cf-swatch[data-color="' + wanted.colour + '"]');
            if (sw) press(sw);
          }
          [].slice.call(document.querySelectorAll('input[name^="section-"][name$="-color"][value="' + wanted.colour + '"]')).forEach(function (r) {
            if (!r.checked) press(r.closest('label') || r);
          });
        }
        if (wanted.fixing) {
          var id = wanted.fixing === 'ground' ? 'shared-mount-inground' : 'shared-mount-base';
          var lab = document.getElementById(id + '-label') || document.getElementById(id);
          press(lab);
          [].slice.call(document.querySelectorAll('[id^="section-"][id$="-ground-post-' + (wanted.fixing === 'ground' ? 'inground' : 'base') + '"]')).forEach(function (r) {
            if (!r.checked) press(document.getElementById(r.id + '-label') || r);
          });
        }
      }
      log('look applied', calc, wanted);
    } catch (e) { log('applyLook failed', e); }
  }

  /* Is this calculator showing something other than the job's look? Used both for the
     short auto-apply window on arrival and for the drift chip afterwards. */
  function lookDiff() {
    var job = J.state();
    var calc = currentCalc();
    if (!calc || !job.look) return null;
    var want = { colour: (calc === 'Frameless') ? job.look.glass : job.look.alu,
                 fixing: (job.fixing && job.fixing !== 'each') ? job.fixing : null };
    var cur = readCurrent() || {};
    var out = {};
    if (want.colour && cur.colour && String(cur.colour).toLowerCase() !== String(want.colour).toLowerCase()) out.colour = cur.colour;
    if (want.fixing && cur.fixing && cur.fixing !== want.fixing) out.fixing = cur.fixing;
    return Object.keys(out).length ? out : null;
  }

  /* ── JOB CHOICES (2026-09-26) ─────────────────────────────────────────────────
     Pete: "perhaps they can make a few choices like colour, basemount or inground and soft
     close hinges on the add sections page then the other section pages can be the standard
     options." Chosen once at Add Sections (or from the strip), pressed ONCE into each
     section's own control, then left alone — so the customer can still change any one
     section, and every price still comes from the calculator. Glass and aluminium colours
     are separate rows because they are different products (glass has Mirror, aluminium has
     Monument); picking a glass colour moves the aluminium one to its match until the
     customer picks aluminium for themselves. Hinges default to the standard hinge (Pete
     14 Sep: default to the margin option, offer the dearer one). */
  var GLASS_COLOURS = [ { v: 'Mirror', n: 'Stainless Mirror' }, { v: 'Black', n: 'Matte Black' }, { v: 'White', n: 'Matte White' } ];
  var ALU_COLOURS   = [ { v: 'satin-black', n: 'Satin Black' }, { v: 'white', n: 'Satin White' }, { v: 'monument', n: 'Monument' } ];
  var GLASS_TO_ALU  = { Black: 'satin-black', White: 'white' };

  /* 26 Sep review: while a NEW plan is being written on the planner page, its choices live
     here, not in the saved job — nothing is saved until Continue. */
  var draftChoices = null;
  function choices() {
    if (draftChoices) return { glass: draftChoices.glass, alu: draftChoices.alu, fixing: draftChoices.fixing, hinge: draftChoices.hinge, aluTouched: !!draftChoices.aluTouched };
    var j = J.state();
    var c = j.choices || {};
    var out = {
      glass:  c.glass  || (j.look && j.look.glass) || 'Mirror',
      alu:    c.alu    || (j.look && j.look.alu)   || 'satin-black',
      fixing: c.fixing || (j.fixing && j.fixing !== 'each' ? j.fixing : null) || 'ground',
      hinge:  c.hinge  || 'standard',
      aluTouched: !!c.aluTouched
    };
    return out;
  }
  function saveChoices(c) {
    if (draftChoices) { draftChoices = { glass: c.glass, alu: c.alu, fixing: c.fixing, hinge: c.hinge, aluTouched: !!c.aluTouched }; return; }
    var j = J.state();
    j.choices = { glass: c.glass, alu: c.alu, fixing: c.fixing, hinge: c.hinge, aluTouched: !!c.aluTouched };
    j.look = null; j.fixing = null;          // the phase-2 look is superseded by this
    J.save(j);
  }
  function choicesLabel() {
    var c = choices(), f = planFenceTypes(), bits = [];
    if (f.glass) bits.push(nameOf(GLASS_COLOURS, c.glass));
    if (f.alu) bits.push(nameOf(ALU_COLOURS, c.alu));
    bits.push(c.fixing === 'base' ? 'Bolted down' : 'In ground');
    if (c.hinge === 'soft') bits.push('Soft-close');
    return bits.join(' · ');
  }
  function nameOf(list, v) { for (var i = 0; i < list.length; i++) if (list[i].v === v) return list[i].n; return v; }

  /* Which kinds of fence the job has: from the plan, else the strip's runs + this page. */
  function planFenceTypes(rowTypes) {
    var types = rowTypes || [];
    if (!types.length) {
      var p = J.getPlan();
      if (p) types = p.items.map(function (it) { return it.calcType; });
      types = types.concat(fencesInJob());
    }
    return { glass: types.indexOf('Frameless') >= 0,
             alu: types.some(function (t) { return t && t !== 'Frameless'; }) };
  }

  function applied() { try { return JSON.parse(sessionStorage.getItem(APPLIED_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function markApplied(k) { var a = applied(); a[k] = 1; try { sessionStorage.setItem(APPLIED_KEY, JSON.stringify(a)); } catch (e) {} }
  function clearApplied() { try { sessionStorage.removeItem(APPLIED_KEY); } catch (e) {} }

  function pickOption(sel, test) {
    if (!sel || !sel.options) return null;
    for (var i = 0; i < sel.options.length; i++) if (test(sel.options[i].value, sel.options[i].text)) return sel.options[i].value;
    return null;
  }
  function hingeValue(sel, want) {
    var soft = function (v, t) { return /soft|PHS/i.test(v + ' ' + t); };
    return want === 'soft' ? pickOption(sel, soft) : pickOption(sel, function (v, t) { return !soft(v, t); });
  }

  /* Press each job choice into a control ONCE per section (keyed calc:section:field). A
     control that is not on the page yet — a hinge before the gate is switched on — is
     simply done later, the first time it appears. */
  function applyChoicesToSections() {
    var calc = currentCalc();
    if (!calc || !J.getPlan()) return;
    var gc = calcInstance();
    var n = 0;
    try { n = (gc && gc.state && gc.state.sectionsCount) || 0; } catch (e) {}
    var c = choices(), done = applied();
    function once(key, fn) {
      if (done[key]) return;
      try { if (fn()) markApplied(key); } catch (e) {}
    }
    for (var i = 1; i <= n; i++) {
      (function (i) {
        var k = calc + ':' + i + ':';
        if (calc === 'Frameless') {
          once(k + 'colour', function () { var el = document.getElementById('section-' + i + '-finish'); if (!el) return false; if (el.value !== c.glass) setSelect(el, c.glass); return true; });
          once(k + 'fixing', function () {
            var el = document.getElementById('section-' + i + '-spigot-type'); if (!el) return false;
            var nc = /non conductive/i.test(el.value) ? 'Non Conductive ' : '';
            var want = nc + (c.fixing === 'base' ? 'Base Mount' : 'Core Drill');
            if (el.value !== want) setSelect(el, want);
            return true;
          });
        } else {
          once(k + 'colour', function () {
            var r = document.querySelector('input[name="section-' + i + '-color"][value="' + c.alu + '"]');
            if (!r) return false;
            if (!r.checked) press(r);
            return true;
          });
          once(k + 'fixing', function () {
            var r = document.getElementById('section-' + i + '-ground-post-' + (c.fixing === 'base' ? 'base' : 'inground'));
            if (!r) return false;
            if (!r.checked) press(r);
            return true;
          });
        }
        once(k + 'hinge', function () {
          var el = document.getElementById('section-' + i + '-hinge-color');
          if (!el || el.offsetParent === null) return false;
          var v = hingeValue(el, c.hinge);
          if (v && el.value !== v) setSelect(el, v);
          return true;
        });
      })(i);
    }
  }

  /* The calculator's own "Are all sections the same? / Configure each individually". A
     mixed job is always individually configured (Pete: "each section will need to be
     configured differently"); saying "Yes, all <fence>" gives the customer back the choice. */
  function forceIndividual(on) {
    try {
      var ind = document.getElementById('add-mode-individual'), same = document.getElementById('add-mode-same');
      if (on && ind && !ind.checked) press(document.getElementById('add-mode-individual-label') || ind);
      if (!on && same && !same.checked) press(document.getElementById('add-mode-same-label') || same);
    } catch (e) {}
  }

  function segRow(title, opts, cur, onPick, swatches) {
    var box = document.createElement('div');
    box.className = 'cf-jc-row';
    var h = document.createElement('div'); h.className = 'cf-jc-row__t'; h.textContent = title; box.appendChild(h);
    var row = document.createElement('div'); row.className = 'cf-jc-seg'; box.appendChild(row);
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cf-jc-opt' + (o.v === cur ? ' on' : '');
      b.setAttribute('data-v', o.v);
      if (swatches && SWATCH[o.v]) {
        var s = document.createElement('i'); s.className = 'cf-jc-sw'; s.style.background = SWATCH[o.v]; b.appendChild(s);
      }
      b.appendChild(document.createTextNode(o.n));
      if (o.sub) { var sm = document.createElement('small'); sm.textContent = o.sub; b.appendChild(sm); }
      b.addEventListener('click', function () {
        [].slice.call(row.children).forEach(function (x) { x.classList.toggle('on', x === b); });
        onPick(o.v);
      });
      row.appendChild(b);
    });
    return box;
  }

  /* The job-choices card. `types()` says which fence kinds are in the job right now, so
     the card only asks about glass or aluminium colour when that kind is in it. */
  function buildChoicesCard(types, onChange) {
    var card = document.createElement('div');
    card.className = 'cf-jc';
    function draw() {
      card.innerHTML = '';
      var c = choices(), f = types();
      var h = document.createElement('div'); h.className = 'cf-jc__h'; h.textContent = 'Choices for the whole job';
      var p = document.createElement('p'); p.className = 'cf-jc__p';
      p.textContent = 'Set once here and filled in on every section. You can still change any single section on its own page.';
      card.appendChild(h); card.appendChild(p);
      if (f.glass) card.appendChild(segRow('Glass hardware colour', GLASS_COLOURS, c.glass, function (v) {
        var cc = choices(); cc.glass = v;
        if (!cc.aluTouched && GLASS_TO_ALU[v]) cc.alu = GLASS_TO_ALU[v];
        saveChoices(cc); draw(); if (onChange) onChange();
      }, true));
      if (f.alu) card.appendChild(segRow('Aluminium colour', ALU_COLOURS, c.alu, function (v) {
        var cc = choices(); cc.alu = v; cc.aluTouched = true; saveChoices(cc); if (onChange) onChange();
      }, true));
      card.appendChild(segRow('How is it fixed?', [
        { v: 'ground', n: 'In ground', sub: f.glass ? 'Core-drilled spigots / concreted posts' : 'Posts concreted in' },
        { v: 'base', n: 'Bolted down', sub: 'Base-mount plates on a slab or deck' }
      ], c.fixing, function (v) { var cc = choices(); cc.fixing = v; saveChoices(cc); if (onChange) onChange(); }));
      card.appendChild(segRow('Gate hinges', [
        { v: 'standard', n: 'Standard self-closing' },
        { v: 'soft', n: 'Soft-close (upgrade)' }
      ], c.hinge, function (v) { var cc = choices(); cc.hinge = v; saveChoices(cc); if (onChange) onChange(); }));
    }
    card.__redraw = draw;
    draw();
    return card;
  }

  /* From the strip, once sections exist: the same card in a panel. "Use on every section"
     is the one place a choice is pressed again over sections already set. */
  function openChoicesPanel() {
    var wrap = document.createElement('div');
    wrap.className = 'cf-jb-panel';
    var box = document.createElement('div');
    box.className = 'cf-jb-panel__box';
    wrap.appendChild(box);
    var before = JSON.stringify(choices());
    box.appendChild(buildChoicesCard(function () { return planFenceTypes(); }));
    var foot = document.createElement('div'); foot.className = 'cf-jb-panel__foot';
    var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'cf-jb-cancel'; cancel.textContent = 'Cancel';
    var done = document.createElement('button'); done.type = 'button'; done.className = 'cf-jb-done'; done.textContent = 'Use on every section';
    foot.appendChild(cancel); foot.appendChild(done); box.appendChild(foot);
    cancel.addEventListener('click', function () {
      try { var b = JSON.parse(before); saveChoices(b); } catch (e) {}
      wrap.remove(); renderStrip();
    });
    wrap.addEventListener('click', function (e) { if (e.target === wrap) cancel.click(); });
    done.addEventListener('click', function () {
      clearApplied();
      applyChoicesToSections();
      wrap.remove();
      setTimeout(renderStrip, 300);
    });
    document.body.appendChild(wrap);
  }

  /* ── JOB SECTION TABS (2026-09-26) — "Glass S1 · Blade S2" ────────────────────
     Pete: "the section selection … all to be selectable from the section 1 and section 2
     etc tabs. lets call them … Glass S1 - Blade S2." In a planned job the calculator's own
     "Section 1, Section 2" pills (which only know this fence) are hidden and this row takes
     their place: every section of the job in the customer's own order. This fence's
     sections open in place (the calculator's own showSection); another fence's section
     saves this fence and opens that one on that section. */
  function localIndex(item) {
    var mine = J.planItemsForCalc(item.calcType);
    for (var i = 0; i < mine.length; i++) if (mine[i].planNum === item.planNum) return i + 1;
    return 1;
  }

  function renderJobTabs() {
    try {
      var here = currentCalc(), plan = J.getPlan();
      var host = document.getElementById('section-tabs-container');
      var old = document.getElementById('cf-job-tabs');
      var on = !!(here && plan && host);
      document.documentElement.classList.toggle('cf-mixjob-tabs', on);
      if (!on) { if (old && old.parentNode) old.parentNode.removeChild(old); return; }

      var gc = calcInstance(), cur = 1;
      try { cur = (gc && gc.state && gc.state.currentSection) || 1; } catch (e) {}
      var have = {};
      J.includedQuotes().forEach(function (q) { have[q.calcType] = true; });
      var items = plan.items.slice().sort(function (a, b) { return a.planNum - b.planNum; });
      var sig = JSON.stringify([items, here, have]);
      if (old && old.getAttribute('data-sig') === sig && old.parentNode === host.parentNode) return;

      /* 27 Sep (Pete: "the sections should show up like normal where it says next: review blade.
         in there you should be able switch between the same types of fencing. still being able
         to add or remove sections of that type of fencing. if you change to the alternative
         fence type you can do the same there"). TWO rows now:
           1. this bar — one tab per FENCE TYPE in the job (switch type; × drops a whole type;
              "+ Another fence type" adds one);
           2. the calculator's own section pills beside "Next: review …", shown as normal and
              labelled with the job's numbers (Blade S1, Blade S3), with its own + Add section and
              Delete section working on this fence type. */
      var types = [], byType = {};
      items.forEach(function (it) {
        if (!byType[it.calcType]) { byType[it.calcType] = []; types.push(it.calcType); }
        byType[it.calcType].push(it);
      });
      var bar = document.createElement('div');
      bar.id = 'cf-job-tabs';
      bar.className = 'cf-jt';
      bar.setAttribute('data-sig', sig);
      bar.setAttribute('role', 'tablist');
      bar.setAttribute('aria-label', 'Fence types in this job');
      var lab = document.createElement('span');
      lab.className = 'cf-jt__lab';
      lab.textContent = 'Fence type:';
      bar.appendChild(lab);
      types.forEach(function (ct) {
        var secs = byType[ct];
        var mine = ct === here;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cf-jt__tab' + (mine ? ' is-active is-here' : ' is-away');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', mine ? 'true' : 'false');
        var dot = document.createElement('span'); dot.className = 'cf-jb__dot'; dot.style.background = fenceColour(ct);
        b.appendChild(dot);
        b.appendChild(document.createTextNode((SHORT[ct] || ct) + (secs.length > 1 ? ' · ' + secs.length + ' sections' : '')));
        var list = secs.map(function (it) {
          return (SHORT[ct] || ct) + ' S' + it.planNum + (it.lengthMm ? ' (' + (it.lengthMm / 1000).toFixed(2) + ' m)' : '');
        }).join(', ');
        if (!mine) {
          var sm = document.createElement('small');
          sm.textContent = have[ct] ? '✓' : '›';
          b.appendChild(sm);
          b.title = 'Open ' + (FENCE[ct] || ct) + ': ' + list + ' (this fence is saved first)';
        } else {
          b.title = (FENCE[ct] || ct) + ': ' + list;
        }
        b.addEventListener('click', function () {
          if (mine) { try { gc.showSection(1); } catch (e) {} return; }
          goToFence(ct, 1);
        });
        var wrapT = document.createElement('span');
        wrapT.className = 'cf-jt__wrap';
        wrapT.appendChild(b);
        if (types.length > 1) {
          var x = document.createElement('button');
          x.type = 'button';
          x.className = 'cf-jt__x';
          x.setAttribute('aria-label', 'Remove all ' + (FENCE[ct] || ct) + ' from this job');
          x.title = x.getAttribute('aria-label');
          x.textContent = '×';
          x.addEventListener('click', function (ev) {
            ev.stopPropagation();
            askRemoveType(wrapT, ct, secs.length);
          });
          wrapT.appendChild(x);
        }
        bar.appendChild(wrapT);
      });
      /* Only fence types NOT in the job yet — a section for a type already in it is added on that
         type's own page with + Add section, where it is really configured and priced (review 27 Sep). */
      var notYet = Object.keys(PATHS).filter(function (ct) { return !byType[ct] && ct !== here; });
      if (notYet.length) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cf-jt__more';
        more.textContent = '+ Another fence type';
        more.addEventListener('click', function (ev) { ev.stopPropagation(); openAddSectionPopover(more, notYet); });
        bar.appendChild(more);
      }
      if (old && old.parentNode) old.parentNode.removeChild(old);
      host.parentNode.insertBefore(bar, host);
    } catch (e) { log('renderJobTabs failed', e); }
  }

  /* × on a fence-type tab: asks in place, then takes every section of that fence out of the job. */
  function askRemoveType(wrapT, ct, n) {
    wrapT.innerHTML = '';
    wrapT.classList.add('is-asking');
    var q = document.createElement('span');
    q.className = 'cf-jt__q';
    q.textContent = 'Remove ' + (FENCE[ct] || ct) + (n > 1 ? ' (all ' + n + ' sections)' : '') + ' from this job?';
    var yes = document.createElement('button'); yes.type = 'button'; yes.className = 'cf-jt__yes'; yes.textContent = 'Remove';
    var no = document.createElement('button'); no.type = 'button'; no.className = 'cf-jt__no'; no.textContent = 'Keep';
    yes.addEventListener('click', function () { removeFenceType(ct); });
    no.addEventListener('click', function () { var o = document.getElementById('cf-job-tabs'); if (o) o.removeAttribute('data-sig'); renderJobTabs(); });
    wrapT.appendChild(q); wrapT.appendChild(yes); wrapT.appendChild(no);
    try { no.focus(); } catch (e) {}          // the safe choice, never Remove (review 27 Sep)
  }
  function removeFenceType(ct) {
    try {
      var plan = J.getPlan();
      if (!plan) return;
      var here = currentCalc();
      var items = plan.items.filter(function (x) { return x.calcType !== ct; })
        .sort(function (a, b) { return a.planNum - b.planNum; });
      if (!items.length) return;             // the last fence type is never removed from here
      items.forEach(function (x, i) { x.planNum = i + 1; });
      J.savePlan(items);
      J.state().runs.filter(function (r) { return r.calcType === ct; })
        .forEach(function (r) { J.removeRun(r.calcType, r.quoteNum); });
      try { sessionStorage.removeItem('cf-calc:' + PATHS[ct]); sessionStorage.removeItem('cf-fresh-hold:' + PATHS[ct]); } catch (e) {}
      /* Leaving the fence that was just removed: straight there, never goToFence — its
         save-first hop would save this fence again and put it back in the job (review 27 Sep). */
      if (ct === here) {
        var to = items[0].calcType;
        try { sessionStorage.setItem(GOTO_KEY, JSON.stringify({ calcType: to, local: 1, at: Date.now() })); } catch (e) {}
        setArrive(to);
        /* Read from the saved plan (J0): this page's fence has just left the plan, so the job
           view J already reads empty here and would hand the next fence no sections. */
        try {
          sessionStorage.setItem(PLAN_PREFILL_KEY, JSON.stringify({ calcType: to, at: Date.now(), reopen: false,
            items: J0.planItemsForCalc(to).map(function (it) { return { planNum: it.planNum, lengthMm: it.lengthMm }; }) }));
        } catch (e) {}
        window.location.replace(PATHS[to]);     // Back must not return to the fence just removed
        return;
      }
      var o = document.getElementById('cf-job-tabs'); if (o) o.removeAttribute('data-sig');
      renderJobTabs(); renderStrip();
    } catch (e) { log('removeFenceType failed', e); }
  }

  /* Any section this calculator holds that the plan does not know about yet (however it was
     added) joins the plan at the end, so it always has a job number and a label. Growth only:
     a section is only ever taken out of the plan by Delete (bindDeleteSync) or a type's ×. */
  /* Re-review 27 Sep: the count box is a hidden select behind a custom dropdown on some
     calculators (PerfMesh), so its change is never "trusted". The customer's own act is the
     real click on step 1's Next — the prefill and the memory replay press it from code. */
  var userCountChange = false;
  document.addEventListener('click', function (ev) {
    try {
      var b = ev.target && ev.target.closest ? ev.target.closest('#sections-next-btn') : null;
      if (b && ev.isTrusted && !planPrefillInFlight) userCountChange = true;
    } catch (e) {}
  }, true);
  function syncPlanToSections() {
    try {
      var here = currentCalc(), gc = calcInstance();
      if (!here || !J.getPlan() || planPrefillInFlight || Date.now() < autoUntil) return;
      var add = document.getElementById('add-sections');
      if (add && add.classList.contains('active')) return;              // still choosing a count on step 1
      var n = (gc && gc.state && gc.state.sectionsCount) || 0;
      var mine = J.planItemsForCalc(here);
      /* Review 27 Sep: the customer lowered the count on this calculator's own step 1 (a real,
         trusted change — never the prefill's own) — the last sections of this fence leave the plan. */
      if (userCountChange && n && n < mine.length) {
        var drop = {};
        mine.slice(n).forEach(function (it) { drop[it.planNum] = true; });
        var keep = J.getPlan().items.filter(function (it) { return !(it.calcType === here && drop[it.planNum]); })
          .sort(function (a, b) { return a.planNum - b.planNum; });
        keep.forEach(function (it, k) { it.planNum = k + 1; });
        J.savePlan(keep);
        userCountChange = false;
        return;
      }
      if (n === mine.length) userCountChange = false;
      if (!n || n <= mine.length) return;
      userCountChange = false;
      for (var i = mine.length + 1; i <= n; i++) {
        var el = document.getElementById('section-' + i + '-length');
        appendPlanItem(here, el ? (parseFloat(el.value) || 0) : 0);
      }
      bindPlanLengthSync(here);
    } catch (e) {}
  }

  function askRemove(wrapT, it) {
    var name = (SHORT[it.calcType] || it.calcType) + ' S' + it.planNum;
    wrapT.innerHTML = '';
    wrapT.classList.add('is-asking');
    var q = document.createElement('span');
    q.className = 'cf-jt__q';
    q.textContent = 'Remove ' + name + '?';
    var yes = document.createElement('button'); yes.type = 'button'; yes.className = 'cf-jt__yes'; yes.textContent = 'Remove';
    var no = document.createElement('button'); no.type = 'button'; no.className = 'cf-jt__no'; no.textContent = 'Keep';
    yes.addEventListener('click', function () { removePlanItem(it); });
    no.addEventListener('click', function () { var o = document.getElementById('cf-job-tabs'); if (o) o.removeAttribute('data-sig'); renderJobTabs(); });
    wrapT.appendChild(q); wrapT.appendChild(yes); wrapT.appendChild(no);
  }

  /* Takes one section out of the job. The plan is renumbered 1, 2, 3; a fence whose sections
     changed loses its saved price (it has to be priced again, and its tab shows ›); a fence with
     no sections left leaves the job. On this page, a section the calculator itself holds is
     removed with the calculator's own Delete; if it was this fence's ONLY section, the customer
     is taken on to the next fence in the job. */
  function removePlanItem(it) {
    try {
      var here = currentCalc(), gc = calcInstance();
      var plan = J.getPlan();
      if (!plan) return;
      var mine = J.planItemsForCalc(it.calcType);
      var li = localIndex(it);
      if (it.calcType === here && mine.length > 1 && gc && gc.state) {
        try { gc.showSection(li); } catch (e) {}
        var del = [].slice.call(document.querySelectorAll('.cf-section-mgmt')).find(function (b) { return /^Delete/.test(b.textContent.trim()); });
        var realConfirm = window.confirm;
        window.confirm = function () { return true; };      // they already said "Remove" here
        try { if (del) { del.__cfAllowed = true; del.click(); } } finally { if (del) del.__cfAllowed = false; window.confirm = realConfirm; }
        return;   // bindDeleteSync renumbers the plan once the calculator has removed it
      }
      var items = plan.items.filter(function (x) { return !(x.calcType === it.calcType && x.planNum === it.planNum); })
        .sort(function (a, b) { return a.planNum - b.planNum; });
      items.forEach(function (x, i) { x.planNum = i + 1; });
      J.savePlan(items);
      J.state().runs.filter(function (r) { return r.calcType === it.calcType; })
        .forEach(function (r) { J.removeRun(r.calcType, r.quoteNum); });
      if (it.calcType === here) {
        try { sessionStorage.removeItem('cf-calc:' + PATHS[here]); } catch (e) {}
        var next = J.planNextCalc(here);
        if (next) { goToFence(next, 1); return; }
        window.location.href = QUOTE_PAGE;
        return;
      }
      var o = document.getElementById('cf-job-tabs'); if (o) o.removeAttribute('data-sig');
      renderJobTabs(); renderStrip();
    } catch (e) { log('removePlanItem failed', e); }
  }

  /* The calculator's own words still say "Section 1" for what is the job's section 2 —
     in the quote breakdown, the summary and "Delete section 1". Relabel the text only. */
  function relabelSections() {
    try {
      var here = currentCalc(), plan = J.getPlan();
      if (!here || !plan) return;
      var mine = J.planItemsForCalc(here);
      if (!mine.length) return;
      var root = document.querySelector('.calculator-page') || document.body;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node, hits = [];
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (!t || t.length > 40) continue;
        if (node.parentNode && node.parentNode.closest && node.parentNode.closest('#cf-job-tabs,#cf-job-strip,.cf-jb-ask,#cf-jb-addsec-pop,option,select,textarea')) continue;
        var m = /^(\s*)(Delete section |Section )(\d+)(\s*(?:Preview)?\s*)$/.exec(t);
        if (m) hits.push([node, m]);
      }
      hits.forEach(function (h) {
        var m = h[1], it = mine[parseInt(m[3], 10) - 1];
        if (!it) return;
        var label = (SHORT[here] || here) + ' S' + it.planNum;
        h[0].nodeValue = m[1] + (m[2] === 'Delete section ' ? 'Delete ' + label : label) + m[4];
      });
    } catch (e) {}
  }

  /* Delete in a job: the calculator removes ITS section n; the plan loses the matching item
     and the job's sections are renumbered 1, 2, 3 so the tabs never skip a number. */
  function bindDeleteSync() {
    if (bindDeleteSync.done) return;
    bindDeleteSync.done = true;
    document.addEventListener('click', function (ev) {
      try {
        var b = ev.target && ev.target.closest ? ev.target.closest('.cf-section-mgmt') : null;
        if (!b || !/^Delete /.test(b.textContent.trim()) || !J.getPlan()) return;
        /* Only the CONFIRMED click: cf-ui-guards.js swallows the first click, asks on the page,
           then re-clicks with __cfAllowed set (as removePlanItem does). Counting both removed a
           second plan item when the customer confirmed within 400 ms (final check, 27 Sep). */
        if (!b.__cfAllowed) return;
        /* Only the CONFIRMED click: cf-ui-guards.js swallows the first click, asks on the page,
           then re-clicks with __cfAllowed set (as removePlanItem does). Counting both removed a
           second plan item when the customer confirmed within 400 ms (final check, 27 Sep). */
        if (!b.__cfAllowed) return;
        var here = currentCalc(), gc = calcInstance();
        var before = (gc && gc.state && gc.state.sectionsCount) || 0;
        var n = (gc && gc.state && gc.state.currentSection) || 1;
        setTimeout(function () {
          try {
            var after = (gc && gc.state && gc.state.sectionsCount) || 0;
            if (after >= before) return;               // cancelled at the confirm
            /* Re-review 27 Sep: two quick Deletes can land inside one 400 ms window (after is then
               before - 2); each click still removes exactly its own section from the plan. */
            var mine = J.planItemsForCalc(here), gone = mine[n - 1];
            if (!gone) return;
            var items = J.getPlan().items.filter(function (it) { return !(it.calcType === here && it.planNum === gone.planNum); })
              .sort(function (a, b2) { return a.planNum - b2.planNum; });
            items.forEach(function (it, i) { it.planNum = i + 1; });
            J.savePlan(items);
            renderJobTabs(); renderStrip();
          } catch (e) {}
        }, 400);
      } catch (e) {}
    }, true);
  }

  /* The fence's own Review step ends in "Add to Cart", which would buy THIS fence alone in
     the middle of a mixed job. In a job it saves this fence and carries on instead. */
  function reviewButtonLabel() {
    var next = J.getPlan() ? J.planNextCalc(currentCalc()) : null;
    return next ? ('Save & continue to ' + (FENCE[next] || next) + ' →') : 'Save & review whole job →';
  }
  function syncReviewButtons() {
    try {
      var btn = document.getElementById('add-to-cart') || document.createElement('button');   // Blade's is #btn-diy-checkout
      if (!btn.getAttribute('data-cf-orig')) btn.setAttribute('data-cf-orig', btn.innerHTML);
      if (mixMode() && J.getPlan()) {
        var want = reviewButtonLabel();
        if (btn.textContent.trim() !== want) btn.textContent = want;
        btn.classList.add('cf-jb-cartbtn');
        var diy = document.getElementById('btn-diy-checkout');
        if (diy) { if (!diy.getAttribute('data-cf-orig')) diy.setAttribute('data-cf-orig', diy.textContent); if (diy.textContent !== want) diy.textContent = want; }
        var cta = document.getElementById('final-quote-cta');
        if (cta) { if (!cta.getAttribute('data-cf-orig')) cta.setAttribute('data-cf-orig', cta.textContent); if (cta.textContent !== want) cta.textContent = want; }
      } else if (btn.classList.contains('cf-jb-cartbtn')) {
        btn.innerHTML = btn.getAttribute('data-cf-orig');
        btn.classList.remove('cf-jb-cartbtn');
        var diy2 = document.getElementById('btn-diy-checkout');
        if (diy2 && diy2.getAttribute('data-cf-orig')) diy2.textContent = diy2.getAttribute('data-cf-orig');
        var cta2 = document.getElementById('final-quote-cta');
        if (cta2 && cta2.getAttribute('data-cf-orig')) cta2.textContent = cta2.getAttribute('data-cf-orig');
      }
    } catch (e) {}
  }
  function bindReviewIntercept() {
    if (bindReviewIntercept.done) return;
    bindReviewIntercept.done = true;
    document.addEventListener('click', function (ev) {
      try {
        if (!(mixMode() && J.getPlan() && currentCalc())) return;
        var t = ev.target && ev.target.closest ? ev.target.closest('#add-to-cart, #final-quote-box, #btn-diy-checkout') : null;
        if (!t) return;
        var real = document.getElementById('add-to-cart');
        if ((real && real.__cfAllowed) || t.__cfAllowed) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        /* Deferred: a browser ignores el.click() on a button whose own click is still being
           dispatched, and PerfMesh saves by clicking this very button (measured 26 Sep). */
        setTimeout(function () { startHop(J.planNextCalc(currentCalc()) || REVIEW); }, 0);
      } catch (e) { log('review intercept failed', e); }
    }, true);
    /* The green quote box is role=button and also answers Enter / Space. */
    document.addEventListener('keydown', function (ev) {
      try {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        if (!(mixMode() && J.getPlan() && currentCalc())) return;
        var t = ev.target && ev.target.closest ? ev.target.closest('#final-quote-box') : null;
        if (!t) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        setTimeout(function () { startHop(J.planNextCalc(currentCalc()) || REVIEW); }, 0);
      } catch (e) {}
    }, true);
  }

  /* EVERY calculator, single fence or mixed (2026-09-26 audit): Configure Sections shows
     up to three buttons all reading "Next →" (the section row, the drawing, the bottom
     bar). They all do the same thing — the next section, then Review — but nothing said
     so. Each now says where it goes. Text only; the calculators find them by id. */
  function syncNextLabels() {
    try {
      var pane = document.getElementById('configure-sections');
      if (!pane || !pane.classList.contains('active')) return;
      var gc = calcInstance();
      if (!gc || !gc.state) return;
      var cur = gc.state.currentSection || 1, count = gc.state.sectionsCount || 0;
      var here = currentCalc(), plan = J.getPlan(), label;
      if (cur < count) {
        var nm = 'Section ' + (cur + 1);
        if (plan && here) { var it = J.planItemsForCalc(here)[cur]; if (it) nm = (SHORT[here] || here) + ' S' + it.planNum; }
        label = 'Next: ' + nm + ' →';
      } else {
        label = (plan && here) ? ('Next: review ' + (SHORT[here] || here) + ' →') : 'Next: review & price →';
      }
      var btns = [document.getElementById('nav-next'), document.getElementById('preview-next-btn')];
      var row = document.getElementById('section-tabs-container');
      if (row) [].slice.call(row.querySelectorAll('button')).forEach(function (b) { if (/^Next/.test(b.textContent.trim())) btns.push(b); });
      btns.forEach(function (b) { if (b && b.offsetParent !== null && b.textContent.trim() !== label) b.textContent = label; });
    } catch (e) {}
  }

  /* On step 1 of a mixed job the calculator's own bottom "Next →" would build every
     section on THIS calculator — the plan's Continue replaces it until they press it. */
  function syncStepOneChrome() {
    try {
      var addPane = document.getElementById('add-sections');
      var onStep1 = !!(addPane && addPane.classList.contains('active'));
      var ask = document.getElementById('cf-job-ask');
      var mixedAsk = !!(ask && ask.classList.contains('is-mixed'));
      document.documentElement.classList.toggle('cf-mixjob', !!(currentCalc() && (mixedAsk || (J.getPlan() && mixMode()))));
      document.documentElement.classList.toggle('cf-mix-step1', onStep1 && mixedAsk);
    } catch (e) {}
  }

  /* ── the strip ─────────────────────────────────────────────────────────────── */

  function runsForStrip() {
    var job = J.state(), out = [];
    job.runs.forEach(function (r) {
      var arr = [];
      try { arr = JSON.parse(localStorage.getItem(J.CALC_KEYS[r.calcType].quotes) || '[]') || []; } catch (e) {}
      for (var i = 0; i < arr.length; i++) {
        if (Number(arr[i].quoteNum) === Number(r.quoteNum)) {
          var q = arr[i];
          var mm = (q.sections || []).reduce(function (s, x) { return s + (parseFloat(x.length) || 0); }, 0);
          out.push({ calcType: r.calcType, quoteNum: r.quoteNum, fence: FENCE[r.calcType] || r.calcType,
                     lengthMm: mm, total: Number(q.grandTotal) || 0 });
          break;
        }
      }
    });
    return out;
  }

  function lookLabel() {
    var job = J.state();
    if (!job.look) return 'Choose the look';
    var l = lookById(job.look.id);
    var fx = job.fixing ? (job.fixing === 'each' ? 'Per fence' : (job.fixing === 'ground' ? 'In ground' : 'Bolted down')) : null;
    return (l ? l.name : 'Look') + (fx ? ' · ' + fx : '');
  }

  /* WHERE THE STRIP GOES. On a calculator it must be visible on EVERY step, so it hangs
     above the step row (.calculator-tabs) — not inside a step's own panel, which is
     display:none whenever the customer is on a different step. */
  function stripHost() {
    if (onQuotePage()) {
      var qn = document.getElementById('qr-quote-nav') || document.getElementById('qr-content');
      return qn ? { el: qn, where: 'before' } : null;
    }
    var tabs = document.querySelector('.calculator-tabs');
    if (tabs) return { el: tabs, where: 'before' };
    var sec = document.getElementById('section-tabs-container') || document.querySelector('.section-tabs');
    if (sec) return { el: sec, where: 'after' };
    var lay = document.querySelector('.calculator-layout');
    return lay ? { el: lay, where: 'before' } : null;
  }

  function renderStrip() {
    try {
      var runs = runsForStrip();
      var old = document.getElementById('cf-job-strip');
      /* 2026-09-26: the strip belongs to an ACTIVE mixed job (or a merged job on the quote page),
         never to a single-fence visit that happens to find an old job in storage. */
      var showStrip = jobActive() || (onQuotePage() && J0.isOn());
      if (!showStrip || (runs.length < 1 && !mixIntent())) { if (old && old.parentNode) old.parentNode.removeChild(old); return; }

      var host = stripHost();
      if (!host) return;

      var here = currentCalc();
      var total = runs.reduce(function (s, r) { return s + r.total; }, 0);

      var bar = old || document.createElement('div');
      bar.id = 'cf-job-strip';
      bar.className = 'cf-jb';
      bar.innerHTML = '';

      var lab = document.createElement('span');
      lab.className = 'cf-jb__lab';
      lab.textContent = 'Your fence job';
      bar.appendChild(lab);

      if (!runs.length) {
        var none = document.createElement('span');
        none.className = 'cf-jb__run';
        none.style.cursor = 'default';
        none.textContent = 'Mixing fence types: set each section’s fence at Add section';
        bar.appendChild(none);
      }

      /* Phone: one line until tapped. The fence being designed stays visible. */
      var closed = bar.getAttribute('data-open') !== '1';
      bar.classList.toggle('is-closed', closed && runs.length > 1);
      if (runs.length > 1) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'cf-jb__more';
        more.textContent = closed ? (runs.length + ' fences ▾') : 'Hide ▴';
        more.addEventListener('click', function () {
          bar.setAttribute('data-open', closed ? '1' : '0');
          renderStrip();
        });
        bar.appendChild(more);
      }

      runs.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cf-jb__run' + (r.calcType === here ? ' is-here' : '');
        var dot = document.createElement('span');
        dot.className = 'cf-jb__dot';
        dot.style.background = fenceColour(r.calcType);
        b.appendChild(dot);
        b.appendChild(document.createTextNode(
          r.fence + ' · ' + (r.lengthMm / 1000).toFixed(1) + ' m · ' + money(r.total)));
        if (r.calcType === here) {
          b.title = 'You are designing this fence';
        } else {
          b.title = 'Open this fence’s quote again';
          b.addEventListener('click', function () { openRun(r); });
        }
        bar.appendChild(b);
      });

      /* "+ Another fence type" was removed from here on 2026-09-25 (Pete: the fence-type
         choice belongs at "+ Add section"). The popover on that button is the one door. */

      var lk = document.createElement('button');
      lk.type = 'button';
      lk.className = 'cf-jb__look';
      lk.textContent = 'Job choices: ' + choicesLabel();
      lk.title = 'Colour, fixing and gate hinges for every section';
      lk.addEventListener('click', function () { openChoicesPanel(); });
      bar.appendChild(lk);

      if (runs.length) {
        var tot = document.createElement('span');
        tot.className = 'cf-jb__tot';
        tot.textContent = money(total);
        bar.appendChild(tot);
      }

      if (!onQuotePage()) {
        /* PLAN (2026-09-24) — item 4: once this fence is priced, carry the customer to
           the next fence type the plan calls for automatically. Once every plan fence type is in
           the job, this goes back to being "Review whole job →" exactly as phase 2 built. */
        var planNext = J.getPlan() ? J.planNextCalc(here) : null;
        var go = document.createElement('button');
        go.type = 'button';
        go.className = 'cf-jb__btn';
        go.textContent = planNext ? ('Continue to ' + (FENCE[planNext] || planNext) + ' →') : 'Review whole job →';
        go.addEventListener('click', function () {
          /* Save what is on screen first, so this fence is in the job the customer is
             about to review. If there is nothing worth saving, just go. */
          var gc = calcInstance();
          var priced = false;
          priced = isPriced(gc);
          var target = planNext || REVIEW;
          if (priced) startHop(target);
          else if (planNext) goToFence(planNext, 1);
          else window.location.href = QUOTE_PAGE;
        });
        bar.appendChild(go);

        /* 2026-09-26: a way out. Clears the mixed job and reopens this calculator as a plain,
           single fence (saved plans are kept). */
        if (jobActive()) {
          var ex = document.createElement('button');
          ex.type = 'button';
          ex.className = 'cf-jb__btn cf-jb__btn--ghost';
          ex.textContent = 'Exit mixed job';
          ex.title = 'Clear this mixed job and go back to a single fence';
          ex.addEventListener('click', function () {
            var ok = true;
            try { ok = window.confirm('Exit the mixed job? This clears every section and fence type in it. Any plans you have saved are kept.'); } catch (e) {}
            if (!ok) return;
            exitJob();
            try { location.replace(location.pathname + '?cf-reset=1'); } catch (e) { location.href = location.pathname + '?cf-reset=1'; }
          });
          bar.appendChild(ex);
        }
      }

      /* Drift: this fence is not wearing the job's look. Offered, never forced. */
      var job = J.state();
      if (false && here && job.look) {
        var diff = (Date.now() >= autoUntil) ? lookDiff() : null;   // quiet during the arrival window
        if (diff) {
          var bits = [];
          if (diff.colour) bits.push(SWATCH_NAME[diff.colour] || diff.colour);
          if (diff.fixing) bits.push(diff.fixing === 'ground' ? 'set in the ground' : 'bolted down');
          var w = document.createElement('div');
          w.className = 'cf-jb__warn';
          w.appendChild(document.createTextNode(
            'This fence is ' + bits.join(' and ') + '. Your job is ' + job.look.name
            + (job.fixing && job.fixing !== 'each' ? ' · ' + (job.fixing === 'ground' ? 'In ground' : 'Bolted down') : '') + '.'));
          var fix = document.createElement('button');
          fix.type = 'button';
          fix.textContent = 'Match the job';
          fix.addEventListener('click', function () {
            autoUntil = Date.now() + 6000;   // let it stick if the calculator re-renders
            applyLook();
            setTimeout(renderStrip, 900);
          });
          w.appendChild(fix);
          bar.appendChild(w);
        }
      }

      if (!bar.parentNode) {
        if (host.where === 'before') host.el.parentNode.insertBefore(bar, host.el);
        else host.el.parentNode.insertBefore(bar, host.el.nextSibling);
      }
    } catch (e) { log('renderStrip failed', e); }
  }

  /* The phase-2 "+ another fence type" menu (openTypeMenu) was retired 2026-09-25 with
     both of its buttons. The fence type is chosen at "+ Add section" (below). */

  /* ── the look panel ────────────────────────────────────────────────────────── */

  function fencesInJob() {
    var out = runsForStrip().map(function (r) { return r.calcType; });
    var here = currentCalc();
    if (here && out.indexOf(here) < 0) out.push(here);
    return out;
  }

  function openLookPanel() {
    var job = J.state();
    var fences = fencesInJob();
    var hasGlass = fences.indexOf('Frameless') >= 0;
    var hasAlu   = fences.some(function (f) { return f !== 'Frameless'; });
    var chosen   = { look: job.look ? job.look.id : 'black', fixing: job.fixing || 'base' };

    var wrap = document.createElement('div');
    wrap.className = 'cf-jb-panel';
    var box = document.createElement('div');
    box.className = 'cf-jb-panel__box';
    wrap.appendChild(box);

    var h = document.createElement('h3'); h.textContent = 'The look of your fence job';
    var sub = document.createElement('p'); sub.className = 'sub';
    sub.textContent = 'Chosen once and used on every fence in this job. You can still change any section afterwards.';
    box.appendChild(h); box.appendChild(sub);

    var h4a = document.createElement('h4'); h4a.textContent = 'Colour';
    box.appendChild(h4a);
    var g1 = document.createElement('div'); g1.className = 'cf-jb-grid'; box.appendChild(g1);

    var available = LOOKS.filter(function (l) {
      if (l.mixOnly)   return hasGlass && hasAlu;
      if (l.glassOnly) return hasGlass && !hasAlu;
      if (l.aluOnly)   return hasAlu && !hasGlass;
      return true;
    });
    if (!available.some(function (l) { return l.id === chosen.look; })) chosen.look = available[0].id;

    available.forEach(function (l) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'cf-jb-card' + (l.id === chosen.look ? ' on' : '');
      c.setAttribute('data-look', l.id);

      var sw = document.createElement('div'); sw.className = 'cf-jb-sw';
      [l.glass, l.alu].forEach(function (v) {
        if (!v) return;
        var i = document.createElement('i'); i.style.background = SWATCH[v]; sw.appendChild(i);
      });
      var nm = document.createElement('b'); nm.textContent = l.name;
      var tg = document.createElement('span');
      tg.className = 'cf-jb-tag' + (hasGlass && hasAlu && !l.match ? ' near' : '');
      tg.textContent = (hasGlass && hasAlu && !l.match) ? 'Glass and aluminium differ' : 'Matches everywhere';
      var nt = document.createElement('small'); nt.textContent = l.note;

      c.appendChild(sw); c.appendChild(nm); c.appendChild(tg); c.appendChild(nt);
      c.addEventListener('click', function () {
        chosen.look = l.id;
        [].slice.call(g1.children).forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-look') === l.id); });
      });
      g1.appendChild(c);
    });

    var h4b = document.createElement('h4'); h4b.textContent = 'How is it fixed?';
    box.appendChild(h4b);
    var g2 = document.createElement('div'); g2.className = 'cf-jb-grid'; box.appendChild(g2);
    FIXINGS.forEach(function (f) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'cf-jb-card' + (f.id === chosen.fixing ? ' on' : '');
      c.setAttribute('data-fix', f.id);
      var nm = document.createElement('b'); nm.textContent = f.name;
      var nt = document.createElement('small'); nt.textContent = f.note;
      c.appendChild(nm); c.appendChild(nt);
      c.addEventListener('click', function () {
        chosen.fixing = f.id;
        [].slice.call(g2.children).forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-fix') === f.id); });
      });
      g2.appendChild(c);
    });

    var foot = document.createElement('div'); foot.className = 'cf-jb-panel__foot';
    var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'cf-jb-cancel'; cancel.textContent = 'Cancel';
    var done = document.createElement('button'); done.type = 'button'; done.className = 'cf-jb-done'; done.textContent = 'Use this look';
    foot.appendChild(cancel); foot.appendChild(done); box.appendChild(foot);

    cancel.addEventListener('click', function () { wrap.remove(); });
    wrap.addEventListener('click', function (e) { if (e.target === wrap) wrap.remove(); });
    done.addEventListener('click', function () {
      try {
        var l = lookById(chosen.look);
        var j = J.state();
        j.look = { id: l.id, glass: l.glass, alu: l.alu, name: l.name };
        j.fixing = chosen.fixing;
        J.save(j);
        applyLook();
        setTimeout(renderStrip, 700);
      } catch (e) { log('look save failed', e); }
      wrap.remove();
    });

    document.body.appendChild(wrap);
  }

  /* ── DOOR B: "Will every section be <this fence>?" on step 1 ───────────────── */

  function renderAsk() {
    try {
      var calc = currentCalc();
      if (!calc) return;
      if (planPrefillInFlight) return;
      if (document.getElementById('cf-job-ask')) return;

      /* Sit under the calculator's own "Are all sections the same?" control, or under
         the section-count question when that one is not on the page. */
      var anchor = document.getElementById('add-mode-group');
      if (!anchor) {
        var count = document.getElementById('sections-count');
        anchor = count ? (count.closest('.form-group') || count.parentElement) : null;
      }
      if (!anchor || !anchor.parentNode) return;

      var fence = FENCE[calc] || 'this fence';
      var wrap = document.createElement('div');
      wrap.className = 'cf-jb-ask form-group';
      wrap.id = 'cf-job-ask';

      var lab = document.createElement('label');
      lab.className = 'cf-jb-ask__lab';
      lab.textContent = 'Will every section be ' + fence + '?';
      wrap.appendChild(lab);

      var row = document.createElement('div');
      row.className = 'cf-jb-ask__row';
      var yes = document.createElement('button');
      yes.type = 'button';
      yes.textContent = 'Yes, all ' + fence;
      var no = document.createElement('button');
      no.type = 'button';
      no.textContent = 'No, I will mix fence types';
      row.appendChild(yes);
      row.appendChild(no);
      wrap.appendChild(row);

      var note = document.createElement('p');
      note.className = 'cf-jb-ask__note';
      note.textContent = 'Give every section its length and fence type, pick the choices for the whole job, then press Continue. '
        + 'Each section then gets its own page, already set up, where you can change anything for that section.';
      wrap.appendChild(note);

      var rowsWrap = document.createElement('div');
      wrap.appendChild(rowsWrap);       // renderPlanRows() fills #cf-job-plan-rows into this

      /* 2026-09-26: the whole-job choices sit right under the sections. */
      var jc = buildChoicesCard(function () {
        var t = [].slice.call(wrap.querySelectorAll('.cf-jb-row__type')).map(function (s) { return s.value; });
        return planFenceTypes(t.length ? t : null);
      });
      jc.classList.add('cf-jc--ask');
      wrap.appendChild(jc);
      wrap.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('cf-jb-row__type')) jc.__redraw(); });

      var err = document.createElement('p');
      err.className = 'cf-jb-plan-err';
      err.textContent = 'Enter a length for every section before continuing.';
      wrap.appendChild(err);

      var cont = document.createElement('button');
      cont.type = 'button';
      cont.className = 'cf-jb-plan-continue';
      cont.textContent = 'Continue with these sections →';
      cont.addEventListener('click', function () { onPlanContinue(err); });
      wrap.appendChild(cont);

      /* Guarded by planPrefillInFlight: once Continue has locked the plan in and set
         THIS calculator's own count from it, that same count change must not rebuild
         the planning rows and look like the customer's earlier picks were lost. */
      function refreshRows() {
        if (planPrefillInFlight) return;
        if (wrap.classList.contains('is-mixed')) renderPlanRows(rowsWrap);
      }

      var countSel = document.getElementById('sections-count');
      if (countSel && !countSel.__cfMixBound) {
        countSel.__cfMixBound = true;
        countSel.addEventListener('change', refreshRows);
      }

      function choose(mixed, byUser) {
        yes.classList.toggle('on', !mixed);
        no.classList.toggle('on', mixed);
        wrap.classList.toggle('is-mixed', mixed);
        setMixIntent(mixed);
        renderStrip();
        if (byUser) forceIndividual(mixed);
        syncStepOneChrome();
        /* The real "Next →" would build every section on THIS calculator — wrong once
           the customer says some sections belong to other fence types. Our own Continue
           button (above) replaces it while mixing is on; the calculator's own button
           comes straight back the moment they answer Yes. */
        var nb = document.getElementById('sections-next-btn');
        if (nb) nb.style.display = mixed ? 'none' : '';
        if (mixed) {
          refreshRows();
          if (byUser && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
      yes.addEventListener('click', function () { choose(false, true); });
      no.addEventListener('click', function () { choose(true, true); });
      choose(mixIntent());

      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } catch (e) { log('renderAsk failed', e); }
  }

  /* ── 2026-09-26 (Pete): single fence works as it used to; mixed fence has its own Add
     Sections page. The calculators no longer ask "Will every section be …?" — they carry one
     quiet link to the planner instead, and only when no mixed job is running. ─────────── */
  var PLANNER_PATH = '/pages/pool-fencing-options';
  var PLANNER_URL = PLANNER_PATH + '?job=new';

  function renderMixLink() {
    try {
      var old = document.getElementById('cf-job-mixlink');
      if (!currentCalc() || jobActive()) { if (old) old.remove(); return; }
      if (old) return;
      var anchor = document.getElementById('add-mode-group');
      if (!anchor) {
        var count = document.getElementById('sections-count');
        anchor = count ? (count.closest('.form-group') || count.parentElement) : null;
      }
      if (!anchor || !anchor.parentNode) return;
      var p = document.createElement('p');
      p.id = 'cf-job-mixlink';
      p.style.cssText = 'margin:14px 0 0;font-size:13px;color:#475569;line-height:1.5';
      p.appendChild(document.createTextNode('Mixing fence types in one job, like glass and Blade? '));
      var a = document.createElement('a');
      a.href = PLANNER_URL;
      a.textContent = 'Plan a mixed fence job →';
      a.style.cssText = 'color:#047857;font-weight:600;text-decoration:underline';
      p.appendChild(a);
      anchor.parentNode.insertBefore(p, anchor.nextSibling);
    } catch (e) { log('renderMixLink failed', e); }
  }

  function renderPlanner() {
    try {
      if (path().indexOf(PLANNER_PATH) !== 0) return;
      if (!/[?&]job=new\b/.test(location.search)) return;
      if (document.getElementById('cf-job-planner')) return;
      if (settling) return;              // an ordered job is being checked against the cart first

      /* Coming back to the planner (Back button) keeps the job being planned. Otherwise this is
         a NEW plan, and — 26 Sep review — landing here changes nothing: no job is switched on and
         no saved job is cleared until Continue is pressed. Leaving without pressing it leaves the
         site exactly as it was (single fence everywhere), and a job being built in another tab
         is not wiped just by opening this page. */
      var existing = (jobActive() && J0.getPlan()) ? J0.getPlan().items.slice().sort(function (a, b) { return a.planNum - b.planNum; }) : null;
      var fresh = !existing;
      if (fresh) draftChoices = { glass: 'Mirror', alu: 'satin-black', fixing: 'ground', hinge: 'standard', aluTouched: false };
      var other = null;
      /* 27 Sep review: any saved plan not yet sent to checkout is offered back, whatever its age
         (it may be open in another tab); one that went to checkout never is. */
      var otherWhen = '';
      if (fresh) try {
        var s0 = J0.state(), made = Date.parse(s0.createdAt) || 0;
        if (!s0.orderedAt && s0.plan && s0.plan.items && s0.plan.items.length) {
          other = s0.plan.items.slice().sort(function (a, b) { return a.planNum - b.planNum; });
          if (made && Date.now() - made > 864e5) otherWhen = ' on ' + new Date(made).toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
        }
      } catch (e) {}

      var main = document.querySelector('main') || document.body;
      var box = document.createElement('div');
      box.id = 'cf-job-planner';
      box.className = 'cf-planner';
      var h = document.createElement('h2'); h.textContent = 'Plan your mixed fence job';
      var p = document.createElement('p'); p.className = 'cf-planner__p';
      p.textContent = 'For each section, choose the type of fence you want, then its length in millimetres. '
        + 'Choose the finishes for the whole job, then press Continue. We take you through each fence type in turn with its sections already filled in, '
        + 'and it all finishes as one quote and one order.';
      box.appendChild(h); box.appendChild(p);

      if (other) {
        var resume = document.createElement('p'); resume.className = 'cf-planner__resume';
        resume.appendChild(document.createTextNode('You started a mixed job ' + (otherWhen ? otherWhen.slice(1) : 'earlier') + ' ('
          + other.map(function (it) { return (SHORT[it.calcType] || FENCE[it.calcType] || it.calcType) + ' S' + it.planNum; }).join(' · ') + '). '));
        var rb = document.createElement('button'); rb.type = 'button'; rb.className = 'cf-planner__resume-btn'; rb.textContent = 'Carry on with it';
        rb.addEventListener('click', function () {
          setActive(true); setMixIntent(true);
          location.replace(PLANNER_URL);
        });
        resume.appendChild(rb);
        resume.appendChild(document.createTextNode(' or plan a new one below.'));
        box.appendChild(resume);
      }

      var rows = document.createElement('div'); rows.className = 'cf-jb-rows cf-planner__rows'; box.appendChild(rows);
      var addBtn = document.createElement('button'); addBtn.type = 'button'; addBtn.className = 'cf-planner__add'; addBtn.textContent = '+ Add a section';
      box.appendChild(addBtn);

      function rowTypes() {
        return [].slice.call(rows.querySelectorAll('.cf-jb-row__type')).map(function (s) { return s.value; }).filter(Boolean);
      }
      var card = buildChoicesCard(function () { return rowTypes().length ? planFenceTypes(rowTypes()) : { glass: false, alu: false }; });
      box.appendChild(card);

      function renumber() {
        [].slice.call(rows.children).forEach(function (r, i) {
          r.querySelector('.cf-jb-row__num').textContent = 'Section ' + (i + 1);
          var x = r.querySelector('.cf-planner__x'); if (x) x.style.visibility = rows.children.length > 1 ? 'visible' : 'hidden';
        });
        addBtn.style.display = rows.children.length >= 10 ? 'none' : '';
      }
      /* Pete, 26 Sep 2026: "for the mixed fence it should start each section with what type of
         fence do you want in this section". Each section is a card: the fence type first, as
         picture tiles, then its length. The <select> stays (hidden) as the one source of truth. */
      function tileImg(ct) {
        try {
          var a = document.querySelector('main a[href*="' + PATHS[ct] + '"] img');
          return a ? (a.currentSrc || a.src) : '';
        } catch (e) { return ''; }
      }
      function addRow(len, type) {
        var row = document.createElement('div'); row.className = 'cf-jb-row cf-planner__sec';
        var head = document.createElement('div'); head.className = 'cf-planner__head';
        var num = document.createElement('span'); num.className = 'cf-jb-row__num';
        var x = document.createElement('button'); x.type = 'button'; x.className = 'cf-planner__x'; x.textContent = '×';
        x.setAttribute('aria-label', 'Remove this section');
        x.addEventListener('click', function () { row.remove(); renumber(); card.__redraw(); });
        head.appendChild(num); head.appendChild(x);

        var q = document.createElement('p'); q.className = 'cf-planner__q';
        q.textContent = 'What type of fence do you want in this section?';
        var sel = document.createElement('select'); sel.className = 'cf-jb-row__type';
        sel.setAttribute('aria-hidden', 'true'); sel.tabIndex = -1;
        var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Choose fence type'; sel.appendChild(o0);
        var tiles = document.createElement('div'); tiles.className = 'cf-planner__tiles';
        tiles.setAttribute('role', 'radiogroup'); tiles.setAttribute('aria-label', 'Fence type for this section');
        Object.keys(PATHS).forEach(function (ct) {
          var o = document.createElement('option'); o.value = ct; o.textContent = FENCE[ct]; sel.appendChild(o);
          var t = document.createElement('button'); t.type = 'button'; t.className = 'cf-planner__tile';
          t.setAttribute('data-ct', ct); t.setAttribute('role', 'radio'); t.setAttribute('aria-checked', 'false');
          var src = tileImg(ct);
          if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; t.appendChild(im); }
          var lb = document.createElement('span'); lb.textContent = FENCE[ct]; t.appendChild(lb);
          t.addEventListener('click', function () {
            sel.value = ct;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            try { inp.focus({ preventScroll: true }); } catch (e) {}
          });
          tiles.appendChild(t);
        });

        var lenWrap = document.createElement('label'); lenWrap.className = 'cf-planner__len';
        var lenT = document.createElement('span'); lenT.textContent = 'How long is this section?';
        var inp = document.createElement('input'); inp.type = 'text'; inp.inputMode = 'numeric'; inp.autocomplete = 'off';
        inp.placeholder = 'Length in mm, e.g. 4000'; inp.className = 'cf-jb-row__len'; inp.value = len || '';
        inp.addEventListener('input', function () {
          var v = inp.value;
          if (/[.,]/.test(v)) v = v.split(/[.,]/)[0];      // decimals are dropped, as on the calculators
          v = v.replace(/[^0-9]/g, '');
          if (v !== inp.value) inp.value = v;
        });
        var mm = document.createElement('span'); mm.className = 'cf-planner__mm'; mm.textContent = 'mm';
        var lenBox = document.createElement('span'); lenBox.className = 'cf-planner__lenbox';
        lenBox.appendChild(inp); lenBox.appendChild(mm);
        lenWrap.appendChild(lenT); lenWrap.appendChild(lenBox);

        function syncTiles() {
          [].slice.call(tiles.children).forEach(function (t) {
            var on = t.getAttribute('data-ct') === sel.value;
            t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          tiles.classList.toggle('is-picked', !!sel.value);
          if (sel.value) tiles.style.outline = '';
          lenWrap.style.display = sel.value ? '' : 'none';     // the length is asked once the type is chosen
        }
        sel.value = type || '';
        sel.addEventListener('change', function () { syncTiles(); card.__redraw(); });
        syncTiles();

        row.appendChild(head); row.appendChild(q); row.appendChild(tiles); row.appendChild(sel); row.appendChild(lenWrap);
        rows.appendChild(row);
        renumber();
      }
      addBtn.addEventListener('click', function () { addRow('', ''); });
      if (existing && existing.length) existing.forEach(function (it) { addRow(it.lengthMm || '', it.calcType); });
      else { addRow('', ''); addRow('', ''); }
      card.__redraw();

      var err = document.createElement('p'); err.className = 'cf-jb-plan-err'; err.style.display = 'none'; box.appendChild(err);
      var go = document.createElement('button'); go.type = 'button'; go.className = 'cf-jb-plan-continue cf-planner__go';
      go.textContent = 'Continue with these sections →';
      go.addEventListener('click', function () {
        var items = [], bad = '';
        [].slice.call(rows.children).forEach(function (r, i) {
          var inp = r.querySelector('.cf-jb-row__len'), sel = r.querySelector('.cf-jb-row__type');
          var mm = parseInt(inp.value, 10) || 0;
          var tl = r.querySelector('.cf-planner__tiles');
          if (tl) tl.style.outline = sel.value ? '' : '2px solid #dc2626';
          inp.style.borderColor = (!sel.value || mm >= 100) ? '' : '#dc2626';
          if (!sel.value) bad = bad || 'Choose the fence type for every section.';
          if (mm < 100) bad = bad || 'Enter a length in millimetres for every section (4 metres = 4000).';
          items.push({ planNum: i + 1, calcType: sel.value, lengthMm: mm });
        });
        if (bad) { err.textContent = bad; err.style.display = 'block'; return; }
        err.style.display = 'none';
        if (draftChoices) {
          /* 27 Sep review: a new plan replaces the one job this browser holds. Read it fresh (another
             tab may have saved one since this page opened) and ask before replacing it. */
          var prev = savedJobLabel();
          if (prev) {
            var sure = true;
            try { sure = window.confirm('Starting this new plan replaces the mixed fence job already saved in this browser (' + prev + '). Your saved quotes are kept. Start the new plan?'); } catch (e2) {}
            if (!sure) return;
          }
          var chosen = draftChoices;
          J0.clear();
          draftChoices = null;
          saveChoices(chosen);
        }
        J0.savePlan(items);
        setActive(true);
        setMixIntent(true);
        clearApplied();
        var first = items[0].calcType;
        hopScreen('Opening the ' + (FENCE[first] || 'first') + ' calculator…', 'Your sections and choices come with you.');
        setTimeout(function () { goToFence(first, 1); }, 300);
      });
      box.appendChild(go);

      main.insertBefore(box, main.firstChild);
      try { box.scrollIntoView({ block: 'start' }); } catch (e) {}
    } catch (e) { log('renderPlanner failed', e); }
  }

  /* The hub page, arrived at from the "Mix fence types" tile: say what is happening,
     because the four range cards below look exactly as they always did. */
  function renderHubBanner() {
    try {
      if (path().indexOf('/pages/pool-fencing-options') !== 0) return;
      if (!mixIntent() || document.getElementById('cf-job-banner')) return;
      var main = document.querySelector('main') || document.body;
      var b = document.createElement('div');
      b.className = 'cf-jb-banner';
      b.id = 'cf-job-banner';
      var t = document.createElement('b');
      t.textContent = 'You are starting a mixed fence job';
      var p = document.createElement('span');
      p.textContent = 'Pick the fence to start with below. At "Add Sections," tell us you’re '
        + 'mixing fence types and set each section’s fence type there — we design this '
        + 'fence’s sections here, then carry you straight to the next fence type with its '
        + 'own sections and lengths already filled in. It all finishes as one quote and one order.';
      b.appendChild(t);
      b.appendChild(p);
      main.insertBefore(b, main.firstChild);
    } catch (e) { log('renderHubBanner failed', e); }
  }

  /* "+ Another fence type" beside the calculator's own "+ Add section" was removed
     2026-09-25 (attachToSectionBar). Pete: the fence-type choice belongs AT "+ Add
     section". Any copy a stale render left behind is taken out by removeAnotherTypeBtn. */
  function removeAnotherTypeBtn() {
    try {
      [].slice.call(document.querySelectorAll('.cf-jb-addtype')).forEach(function (b) {
        if (b.parentNode) b.parentNode.removeChild(b);
      });
    } catch (e) {}
  }

  /* Mix mode = the job strip is showing (a run in the job, or the customer said they are
     mixing) or a plan exists. Without the old "+ Another fence type" button, this is what
     lets a job started before the plan existed still add a different fence: "+ Add section"
     asks. A single-fence customer has none of these, so their "+ Add section" is untouched. */
  function mixMode() {
    try { return jobActive(); } catch (e) { return false; }
  }

  /* PLAN (2026-09-24, revised same day on the coordinator's review) — item 1's last
     sentence: "+ Add section" in mix mode asks which fence type the new section is.
     Pete's whole point of this build is that the fence type is chosen AT Add Sections,
     so this is now a proper on-brand popover — full-width 44px rows in the brand-green
     outline of the calculator's own "+ Add section" (v2, 2026-09-25) — not a prompt().
     Bound once per page load, in the CAPTURE phase, so it runs before the calculator's
     own handler. Picking THIS page's fence lets the native click through untouched (plus
     plan bookkeeping); any other fence opens an inline length box in the same popover and
     appends a plan item WITHOUT adding a section here. */
  var addSectionAskBound = false;

  function closeAddSectionPopover() {
    var p = document.getElementById('cf-jb-addsec-pop');
    if (p && p.parentNode) p.parentNode.removeChild(p);
    document.removeEventListener('click', addSecOutsideCloser, true);
    document.removeEventListener('keydown', addSecEscCloser, true);
  }
  /* 2026-09-26 (Pete): pressing inside and releasing outside is a drag, not a click-outside. */
  var addSecDown = null;
  document.addEventListener('pointerdown', function (e) { addSecDown = e.target; }, true);
  function addSecOutsideCloser(e) {
    var p = document.getElementById('cf-jb-addsec-pop');
    if (p && addSecDown && p.contains(addSecDown)) return;
    if (p && !p.contains(e.target)) closeAddSectionPopover();
  }
  function addSecEscCloser(e) {
    if (e.key === 'Escape') closeAddSectionPopover();
  }

  function positionAddSectionPopover(pop, anchor) {
    var r = anchor.getBoundingClientRect();
    var maxW = Math.min(320, window.innerWidth - 16);
    pop.style.position = 'absolute';
    pop.style.maxWidth = maxW + 'px';
    pop.style.top = (window.scrollY + r.bottom + 6) + 'px';
    var left = window.scrollX + r.left;
    var overflowRight = (left + maxW) - (window.scrollX + window.innerWidth - 8);
    if (overflowRight > 0) left -= overflowRight;
    pop.style.left = Math.max(8, left) + 'px';
  }

  /* A job already in progress (started before 24 Sep, or with the old button) has no
     plan. Seed one from THIS calculator's own sections first, so the new section is
     numbered after them and the job's section numbers still read 1, 2, 3 in order. */
  function seedPlanFromHere() {
    var here = currentCalc();
    var items = [];
    if (!here) return items;
    var n = 0;
    try { var gc = calcInstance(); n = (gc && gc.state && gc.state.sectionsCount) || 0; } catch (e) {}
    if (!n) n = document.querySelectorAll('[id^="section-"][id$="-length"]').length;
    for (var i = 1; i <= n; i++) {
      var el = document.getElementById('section-' + i + '-length');
      var mm = el ? (parseFloat(el.value) || 0) : 0;
      items.push({ planNum: i, calcType: here, lengthMm: mm });
    }
    return items;
  }

  function appendPlanItem(calcType, lengthMm) {
    var plan = J.getPlan();
    var items = plan ? plan.items.slice() : seedPlanFromHere();
    var maxNum = items.reduce(function (m, it) { return Math.max(m, it.planNum); }, 0);
    items.push({ planNum: maxNum + 1, calcType: calcType, lengthMm: lengthMm });
    J.savePlan(items);
    renderPlanSummary();
    renderStrip();
    return items[items.length - 1];
  }

  /* "This page's fence" was picked: let the real "+ Add section" run untouched, add the
     matching plan item (length 0 until the customer types one), then watch the new
     section's own length field and sync the plan item from it the moment they do — so
     the plan stays accurate for the customer's-own-numbers feature without asking twice. */
  function addSectionHereFromPlan(nativeBtn) {
    var here = currentCalc();
    var before = document.querySelectorAll('[id^="section-"][id$="-length"]').length;
    /* Seed BEFORE the native click, or the seed would already count the new section. */
    if (!J.getPlan()) { var seed = seedPlanFromHere(); if (seed.length) J.savePlan(seed); }
    /* Deferred: a click() on the same button from inside its own click dispatch is ignored by
       the browser (the 26 Sep PerfMesh hop trap), which would add a plan item with no section. */
    setTimeout(function () {
      try {
        var gc = calcInstance(), n0 = (gc && gc.state && gc.state.sectionsCount) || 0;
        nativeBtn.__cfAllowed = true;
        try { nativeBtn.click(); } finally { nativeBtn.__cfAllowed = false; }
        var n1 = (gc && gc.state && gc.state.sectionsCount) || 0;
        if (gc && gc.state && n1 <= n0) return;          // nothing was added (e.g. at the maximum)
        appendPlanItem(here, 0);
        /* Delegated, not bound to the input: the calculator re-renders its section fields
           (generateSectionTabs), which silently dropped a listener on the element itself —
           measured 2026-09-25, the plan kept 0 mm after the customer typed 2000. */
        bindPlanLengthSync(here);
      } catch (e) { log('add section failed', e); }
    }, 0);
  }

  /* Once a section has been added here from the plan, every length this page's own
     "#section-N-length" takes is kept in the plan as this fence's Nth plan item. */
  var planLengthSyncFor = null;
  function bindPlanLengthSync(here) {
    if (planLengthSyncFor) return;
    planLengthSyncFor = here;
    function sync(ev) {
      try {
        var el = ev.target;
        var m = el && el.id ? /^section-(\d+)-length$/.exec(el.id) : null;
        if (!m) return;
        var mm = parseFloat(el.value);
        if (!(mm > 0)) return;
        var here = planLengthSyncFor;
        var local = parseInt(m[1], 10);   // this calculator's own section no.
        var plan = J.getPlan();
        if (!plan) return;
        var items = plan.items.slice();
        var mine = items.filter(function (it) { return it.calcType === here; })
                        .sort(function (a, b) { return a.planNum - b.planNum; });
        var target = mine[local - 1];
        if (target && target.lengthMm !== mm) {
          target.lengthMm = mm;
          J.savePlan(items);
          renderPlanSummary();
        }
      } catch (e) {}
    }
    document.addEventListener('change', sync, true);
    document.addEventListener('blur', sync, true);
  }

  /* A different fence was picked: swap the popover to a length box, in place — no new
     popover, so it stays anchored and the customer never loses their place. */
  function showAddSectionLengthStep(pop, calcType) {
    var body = pop.querySelector('.cf-jb-addsec-pop__body');
    body.innerHTML = '';
    var lab = document.createElement('label');
    lab.className = 'cf-jb-addsec-pop__lab';
    lab.textContent = 'Length of the new ' + (FENCE[calcType] || calcType) + ' section (mm)';
    var row = document.createElement('div');
    row.className = 'cf-jb-addsec-pop__row';
    var input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    input.className = 'cf-jb-row__len';
    input.placeholder = 'e.g. 5000';
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'cf-jb__btn';
    add.textContent = 'Add';
    function commit() {
      var mm = parseFloat(input.value);
      if (!(mm > 0)) { input.style.borderColor = '#dc2626'; input.focus(); return; }
      appendPlanItem(calcType, mm);
      closeAddSectionPopover();
    }
    add.addEventListener('click', commit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commit(); } });
    row.appendChild(input); row.appendChild(add);
    body.appendChild(lab); body.appendChild(row);
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 30);
  }

  function openAddSectionPopover(anchorBtn, othersOnly) {
    closeAddSectionPopover();
    var here = currentCalc();
    var pop = document.createElement('div');
    pop.id = 'cf-jb-addsec-pop';
    pop.className = 'cf-jb-addsec-pop';

    var head = document.createElement('div');
    head.className = 'cf-jb-addsec-pop__head';
    var title = document.createElement('span');
    title.textContent = othersOnly ? 'Add another fence type' : 'New section — which fence?';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cf-jb-addsec-pop__x';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    close.addEventListener('click', function (e) { e.stopPropagation(); closeAddSectionPopover(); });
    head.appendChild(title); head.appendChild(close);
    pop.appendChild(head);

    var body = document.createElement('div');
    body.className = 'cf-jb-addsec-pop__body';
    pop.appendChild(body);

    /* This page's fence first, then the others in the usual order. */
    /* othersOnly: the list of fence types to offer (not in the job yet), from "+ Another fence type". */
    var order = othersOnly ? othersOnly.slice()
      : Object.keys(PATHS).filter(function (ct) { return ct === here; })
          .concat(Object.keys(PATHS).filter(function (ct) { return ct !== here; }));
    order.forEach(function (ct) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cf-jb-addsec-choice';
      b.setAttribute('data-fence', ct);
      var dot = document.createElement('span');
      dot.className = 'cf-jb__dot';
      dot.style.background = fenceColour(ct);
      dot.setAttribute('aria-hidden', 'true');
      b.appendChild(dot);
      b.appendChild(document.createTextNode(FENCE[ct] || ct));
      if (ct === here) {
        var tag = document.createElement('small');
        tag.textContent = 'this page';
        b.appendChild(tag);
      }
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (ct === here) {
          var nativeBtn = anchorBtn;
          closeAddSectionPopover();
          addSectionHereFromPlan(nativeBtn);
        } else {
          showAddSectionLengthStep(pop, ct);
        }
      });
      body.appendChild(b);
    });

    document.body.appendChild(pop);
    positionAddSectionPopover(pop, anchorBtn);
    setTimeout(function () { try { var f = pop.querySelector('.cf-jb-addsec-choice'); if (f) f.focus(); } catch (e) {} }, 30);
    setTimeout(function () {
      document.addEventListener('click', addSecOutsideCloser, true);
      document.addEventListener('keydown', addSecEscCloser, true);
    }, 0);
  }

  function bindAddSectionAsk() {
    if (addSectionAskBound) return;
    addSectionAskBound = true;
    document.addEventListener('click', function (ev) {
      try {
        if (!mixMode()) return;
        var el = ev.target && ev.target.closest ? ev.target.closest('.cf-section-mgmt') : null;
        if (!el || el.classList.contains('cf-jb-addtype') || el.classList.contains('cf-jb-addsec-choice') || el.__cfAllowed) return;
        if (el.textContent.trim() !== '+ Add section') return;
        if (!currentCalc()) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        addSectionHereFromPlan(el);         // 27 Sep: this fence type; other types from "+ Another fence type"
      } catch (e) { log('bindAddSectionAsk failed', e); }
    }, true);
  }

  /* ── install ───────────────────────────────────────────────────────────────── */

  var autoUntil = 0;

  function tick() {
    try {
      renderStrip();
      removeAnotherTypeBtn();
      bindAddSectionAsk();
      renderMixLink();      // 2026-09-26: replaces the step-1 "Will every section be …?" question
      renderPlanner();      // 2026-09-26: the mixed-fence Add Sections page (hub ?job=new)
      renderPlanSummary();
      watchOrder();         // 27 Sep review: stamp a job that goes to checkout
      mixTick();
    } catch (e) {}
  }

  /* 2026-09-26: the job tabs, choices and review button must keep up with the calculator
     for as long as the customer is on the page (a hinge appears when a gate is switched on
     minutes later), so this light pass never stops — but does nothing outside a job. */
  /* 2026-09-26 (break test F2): on the quote page a job must never quietly become one fence.
     A run whose saved quote has no real total is taken out of the job (it can only make merge()
     refuse the whole job), and any fence the PLAN calls for that is not priced yet is named at the
     top of the page with a button straight to it — instead of the old silent fall-back, where the
     strip said $1,786.67 and Continue to Payment charged $970.15. */
  function planGapNotice() {
    try {
      if (!onQuotePage()) return;
      var j = J.state(), pruned = false;
      j.runs.slice().forEach(function (r) {
        var arr = [];
        try { arr = JSON.parse(localStorage.getItem(J.CALC_KEYS[r.calcType].quotes) || '[]') || []; } catch (e) {}
        var q = null;
        for (var i = 0; i < arr.length; i++) if (Number(arr[i].quoteNum) === Number(r.quoteNum)) q = arr[i];
        if (q && !(Number(q.grandTotal) > 0)) { J.removeRun(r.calcType, r.quoteNum); pruned = true; }
      });
      if (pruned) setTimeout(function () { try { location.reload(); } catch (e) {} }, 50);
      var plan = J.getPlan();
      var old = document.getElementById('cf-job-gap');
      if (!plan) { if (old) old.remove(); return; }
      var have = {};
      J.includedQuotes().forEach(function (q) { if (Number(q.grandTotal) > 0) have[q.calcType] = true; });
      var missing = plan.items.filter(function (it) { return !have[it.calcType]; })
        .sort(function (a, b) { return a.planNum - b.planNum; });
      if (!missing.length) { if (old) old.remove(); return; }
      var sig = JSON.stringify(missing);
      if (old && old.getAttribute('data-sig') === sig) return;
      if (old) old.remove();
      var b = document.createElement('div');
      b.id = 'cf-job-gap';
      b.className = 'cf-jb-banner cf-jb-gap';
      b.setAttribute('data-sig', sig);
      var t = document.createElement('b');
      t.textContent = 'Not in this order yet: ' + missing.map(function (it) {
        return (SHORT[it.calcType] || it.calcType) + ' S' + it.planNum + (it.lengthMm ? ' (' + (it.lengthMm / 1000).toFixed(1) + ' m)' : '');
      }).join(', ');
      var p = document.createElement('span');
      p.textContent = 'The total below does not include ' + (missing.length > 1 ? 'these sections' : 'this section')
        + ' — finish pricing it and it joins this order.';
      b.appendChild(t); b.appendChild(p);
      var first = missing[0];
      var go = document.createElement('button');
      go.type = 'button';
      go.className = 'cf-jb__btn';
      go.style.marginTop = '8px';
      go.textContent = 'Finish ' + (SHORT[first.calcType] || first.calcType) + ' S' + first.planNum + ' →';
      go.addEventListener('click', function () { goToFence(first.calcType, localIndex(first)); });
      b.appendChild(document.createElement('br'));
      b.appendChild(go);
      var host = stripHost();
      if (host && host.el && host.el.parentNode) host.el.parentNode.insertBefore(b, host.el);
    } catch (e) { log('planGapNotice failed', e); }
  }

  function mixTick() {
    try {
      planGapNotice();
      syncStepOneChrome();
      syncReviewButtons();
      syncNextLabels();
      /* 27 Sep: while the fence fills itself in (memory replay + plan prefill, up to ~10 s), the
         sections used to read "Section 1 / Section 2" and "Delete section 1". Relabelling is
         text only, so it is safe to keep doing it during the prefill. */
      if (!currentCalc() || !J.getPlan() || planPrefillInFlight) {
        renderJobTabs();
        if (currentCalc() && J.getPlan()) relabelSections();
        return;
      }
      syncPlanToSections();
      renderJobTabs();
      applyChoicesToSections();
      relabelSections();
    } catch (e) {}
  }

  /* ── 27 Sep review: a job that has gone to checkout ─────────────────────────────
     quote-review.js sets its submit button to "Redirecting…" only after the cart was cleared,
     the job added and the note written, right before /checkout. That is the stamp (its fetch is
     its own reference, so a fetch wrapper here would never see the call). The stamp records the
     cart it went to checkout with (the "cart" cookie, read at that instant).
     Second review (27 Sep): "Redirecting…" is a checkout ATTEMPT, not a payment. So on the next
     page load: if that cart is gone (Shopify replaced it after the order) or empty, the order went
     through and the job is finished — never offered back or merged again. If the same cart still
     holds items, checkout was abandoned: the stamp is taken off and the job is an ordinary saved
     job again (Carry on offered, a new plan asks before replacing it). */
  var settling = false;
  function cartCookie() {
    try {
      var m = /(?:^|;\s*)cart=([^;]*)/.exec(document.cookie || '');
      return m ? decodeURIComponent(m[1]).split('?')[0] : '';
    } catch (e) { return ''; }
  }
  function markOrdered() {
    try {
      var j = J0.state();
      if (!j.orderedAt) { j.orderedAt = new Date().toISOString(); j.orderedCart = cartCookie(); J0.save(j); }
    } catch (e) {}
  }
  function watchOrder() {
    try {
      if (!onQuotePage()) return;
      var btn = document.querySelector('#qr-enquire-form button[type="submit"]');
      if (!btn || btn.__cfJobWatch) return;
      btn.__cfJobWatch = true;
      new MutationObserver(function () {
        /* a merged job, or a planned job cut down to one fence type (isOn needs two) */
        if (/^Redirecting/.test((btn.textContent || '').trim()) && (J0.isOn() || J.getPlan())) markOrdered();
      }).observe(btn, { childList: true, characterData: true, subtree: true });
    } catch (e) {}
  }
  function settleOrderedJob() {
    try {
      if (!J0.state().orderedAt) return;
      settling = true;
      var done = function () { settling = false; };
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); }).then(function (cart) {
        var j = J0.state();
        if (!j.orderedAt) return done();
        var now = String((cart && cart.token) || '').split('?')[0];
        var replaced = !!(j.orderedCart && now && now !== j.orderedCart);
        /* Re-review 27 Sep: ONLY a replaced cart means the order went through (Shopify starts a new
           cart after a completed checkout). A customer emptying the same cart themselves after
           backing out of checkout is still an unpaid job — never wipe it for that. */
        if (replaced) { J0.clear(); setActive(false); }
        else { delete j.orderedAt; delete j.orderedCart; J0.save(j); }       // checkout abandoned
        done();
      }).catch(done);
      setTimeout(done, 5000);
    } catch (e) { settling = false; }
  }
  /* The job a new plan would replace, as the customer knows it — '' when there is nothing to lose. */
  function savedJobLabel() {
    try {
      var j = J0.state();
      if (j.orderedAt) return '';
      var items = (j.plan && j.plan.items) || [];
      if (items.length) return items.slice().sort(function (a, b) { return a.planNum - b.planNum; })
        .map(function (it) { return (SHORT[it.calcType] || FENCE[it.calcType] || it.calcType) + ' S' + it.planNum; }).join(' · ');
      if (j.on && j.runs && j.runs.length) return j.runs.map(function (x) { return SHORT[x.calcType] || FENCE[x.calcType] || x.calcType; }).join(' + ');
    } catch (e) {}
    return '';
  }

  function start() {
    settleOrderedJob();
    css();
    if (onQuotePage() && finishHop()) return;   // leaving this page again straight away
    hopClear();
    /* "?job=new" - the homepage tile, the hub card and the mega menu tile all use it. */
    /* It opens the planner (renderPlanner); nothing is flagged until its Continue (26 Sep review). */
    autoUntil = Date.now() + 12000;          // the arrival window, then hands off
    /* PLAN (2026-09-24): a hop or a "go back" chip waiting for this page. Re-review 27 Sep: a job
       that went to checkout is checked against the cart first, so a paid job's old plan is never
       typed into a calculator opened afterwards. */
    if (!onQuotePage()) {
      var waitSettle = 0;
      (function prefillWhenSettled() {
        if (settling && waitSettle++ < 60) { setTimeout(prefillWhenSettled, 100); return; }
        checkPlanPrefill();
      })();
    }
    tick();
    var n = 0;
    var iv = setInterval(function () { n++; tick(); if (n > 60) clearInterval(iv); }, 800);
    document.addEventListener('cf-job:changed', function () { setTimeout(renderStrip, 50); });
    bindDeleteSync();
    bindReviewIntercept();
    setInterval(mixTick, 1000);
    log('installed on', path(), 'calc=', currentCalc());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
